<template lang="pug">
div(style="width: 100%;")
  //- DETAILS POLIZAS
  v-dialog#dialog-rentas(v-model="flags.showAnnuity" fullscreen hide-overlay persistent transition='dialog-bottom-transition' style="width: 100% !important;")
    v-card(v-if="flags.showAnnuity" style="width: 100% !important;")
      v-toolbar#toolbar.header-info-policy(dark color="primary")
        v-btn.btn-backspace(outline flat fab small @click="closeModal('rentas')")
          v-icon keyboard_backspace
        v-toolbar-title
          h3(style="color: #fff !important;")
            | {{ selected.annuity.producto }}
      v-card-text#annuity-content
        v-container(v-bind:class="{ 'grid-list-md': $vuetify.breakpoint.mdAndUp }")
          form-annuity(:annuity="selected.annuity")
  v-dialog#dialog-vida(v-model="flags.showGuaranteed" fullscreen hide-overlay persistent transition='dialog-bottom-transition' style="width: 100% !important;")
    v-card(v-if="flags.showGuaranteed" style="width: 100% !important;")
      v-toolbar#toolbar.header-info-policy(dark color='primary')
        v-btn.btn-backspace(outline flat fab small @click="closeModal('vida')")
          v-icon keyboard_backspace
        v-toolbar-title
          h3(style="color: #fff !important;")
            | {{ selected.guaranteed.producto }}
      v-card-text#guaranteed
        v-container(v-bind:class="{ 'grid-list-md': $vuetify.breakpoint.mdAndUp }")
          form-guaranteed-education(:guaranteed="selected.guaranteed")
  v-dialog#dialog-masivos(v-model="flags.showMasivo" fullscreen hide-overlay persistent transition='dialog-bottom-transition' style="width: 100% !important;")
    v-card(v-if="flags.showMasivo" style="width: 100% !important;")
      v-toolbar#toolbar.header-info-policy(dark color='primary')
        v-btn.btn-backspace(outline flat fab small @click="closeModal('masivo')")
          v-icon keyboard_backspace
        v-toolbar-title
          h3(style="color: #fff !important;")
            | {{ selected.masivo.producto }}
      v-card-text#guaranteed
        v-container(v-bind:class="{ 'grid-list-md': $vuetify.breakpoint.mdAndUp }")
          form-masivo(:guaranteed="selected.masivo")
  // QUITANDO CLASES PARA CUANDO ES VIVE+
  div(:class="{'inicio-main-dash': ($route.path !== '/vivemas')}" style="width: 100%;")
    .inicio-panel.mt-2.border-radius-top
      .inicio-panel-content
        h1 Hola, {{ profileName }}
        .inicio-panel-banner
          figure
            img(:src="mainBanner.img")
          article
            div
              h3 {{ mainBanner.title }}
              p {{ mainBanner.parraf }}
          button(@click="makeMainRequeriment(mainBanner)") {{ mainBanner.button }}
        .inicio-panel-block-1.mt-3
          h2 Mis seguros
          .inicio-panel-block-1-list.g-flex.g-flex-wrap
            //- CAROUSEL POLIZAS
            v-carousel(hide-delimiters, :prev-icon="false" :cycle="!$vuetify.breakpoint.mdAndUp")
              template(v-for='(item, index) in listSeguros')
                v-carousel-item(v-if='(index + 1) % columns === 1 || columns === 1' :key='index')
                  .row.d-flex.flex-nowrap(style='height:100%; gap:22px', :name='item.title')
                    template(v-for='(n,i) in columns')
                      template(v-if='(+index + i) < listSeguros.length')
                        .col(:key='i', :name='item.title')
                          article(@click="display(listSeguros[+index+i].policy)")
                            figure.text-xs-center
                              img(:src="listSeguros[+index+i].img")
                            .inicio-panel-block-1-descrip
                              h3 {{ listSeguros[+index+i].title }}
                              .g-flex.justify-space-between
                                p {{ listSeguros[+index+i].txt1A }}
                                p {{ listSeguros[+index+i].txt1B }}
                              .g-flex.justify-space-between
                                p {{ listSeguros[+index+i].txt2A }}
                                p {{ listSeguros[+index+i].txt2B }}
                                v-menu(v-if="$vuetify.breakpoint.mdAndUp" v-model='listSeguros[+index+i].noti' open-on-hover :close-on-content-click='false' :nudge-bottom='15' :nudge-left='165' offset-x='')
                                  template(v-slot:activator='{ on }')
                                    svg(v-on="on" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg")
                                      g(clip-path="url(#clip0)")
                                        path(d="M5.61833 11.2367C8.72126 11.2367 11.2367 8.72126 11.2367 5.61833C11.2367 2.51541 8.72126 0 5.61833 0C2.51541 0 0 2.51541 0 5.61833C0 8.72126 2.51541 11.2367 5.61833 11.2367Z" fill="#D0D6E0")
                                        path(d="M5.51683 6.71214C5.71995 6.71214 5.86257 6.65034 5.87899 6.51766C5.89671 5.89013 6.32976 5.63471 6.7628 5.3512C7.01509 5.23222 7.22906 5.04503 7.38051 4.81078C7.53196 4.57654 7.61485 4.3046 7.61981 4.02571C7.61981 3.15098 6.92184 2.52345 5.77311 2.52345C5.25045 2.5006 4.73868 2.67752 4.34173 3.0183C4.20924 3.13053 4.10039 3.268 4.02152 3.4227C3.94265 3.5774 3.89533 3.74624 3.88232 3.91939C3.88232 4.39479 4.49213 4.41424 4.50077 4.38787C4.51996 4.0734 4.66225 3.77915 4.89683 3.56883C5.13141 3.35852 5.4394 3.24908 5.75409 3.26421C6.39026 3.26421 6.75243 3.59094 6.75243 4.09486C6.75243 4.55426 6.36347 4.72238 5.96586 4.98731C5.7126 5.12798 5.50246 5.335 5.35801 5.58613C5.21357 5.83725 5.14028 6.12299 5.14602 6.41264C5.13694 6.6149 5.29598 6.71214 5.51683 6.71214ZM5.47361 8.40844H5.59721C5.66212 8.41694 5.7281 8.41059 5.79019 8.38987C5.85228 8.36914 5.90885 8.33458 5.95564 8.2888C6.00242 8.24302 6.03819 8.18721 6.06025 8.12558C6.08231 8.06395 6.09008 7.99812 6.08298 7.93304V7.82716C6.09097 7.76128 6.08389 7.69445 6.06228 7.6317C6.04067 7.56895 6.00509 7.51194 5.95823 7.46495C5.91136 7.41796 5.85444 7.38223 5.79175 7.36045C5.72907 7.33867 5.66225 7.33142 5.59635 7.33923H5.47275C5.40782 7.3328 5.34228 7.34104 5.28096 7.36334C5.21965 7.38564 5.16413 7.42142 5.11849 7.46805C5.07286 7.51468 5.03828 7.57096 5.01731 7.63274C4.99635 7.69452 4.98952 7.76023 4.99735 7.825V7.93088C4.9896 7.99527 4.99655 8.06058 5.01767 8.12189C5.03879 8.18321 5.07353 8.23894 5.11929 8.2849C5.16504 8.33086 5.22061 8.36585 5.28183 8.38725C5.34305 8.40865 5.40832 8.41589 5.47275 8.40844H5.47361Z" fill="white")
                                      defs
                                        clipPath(id="clip0")
                                          rect(width="11.2367" height="11.2367" fill="white")
                                  v-card.tooltip-dash-info-poliza
                                    span
                                      | {{ listSeguros[+index+i].notiText }}
            .inicio-panel-block-1-btn(v-if="flags.showNextIcon && $vuetify.breakpoint.mdAndUp")
              svg(width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg")
                path(d="M9.9973 19.332L15.879 13.4503L9.9973 7.56853L9.26221 8.30362L14.4089 13.4503L9.26221 18.5969L9.9973 19.332Z" fill="#0855C4")
        .inicio-panel-block-2(:class="{'f-wrap': (flags.loanAvailable || flags.isRentas) && (flags.cvcAvailable || flags.paymentsAvailable) && $vuetify.breakpoint.mdAndUp}")
          // SI PUEDE HACER CVC O PRESTAMO, HABILITAR ESTA SECCIÓN
          // .mt-4
          .inicio-panel-pagos(v-if="flags.cvcAvailable || flags.loanAvailable || flags.paymentsAvailable || flags.isRentas")
            h2 Mis pagos
            .inicio-panel-pagos-list
              // OPCIÓN DE MIS PAGOS CUANDO AMERITA
              article.pl-3.pr-2(v-if="flags.paymentsAvailable")
                .g-flex.align-center.justify-space-between(@click="goPagoCuotas" :class="(paymentsWait)?'cursor-progress':'cursor-pointer'")
                  .g-flex.align-center
                    figure(style="width: 35px;")
                      img(src="../assets/new-home/img-calendar.svg")
                    .ml-3
                      h3 Mes {{getMesActual()}}
                      p(:style="(paymentsPendings.includes('pendientes') ? 'color: #EB5757;' : 'color: #40C2A6;')") {{ paymentsPendings }}
                  svg(width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg")
                    path(d="M8.27509 5.98722C8.19268 6.06977 8.12731 6.16782 8.0827 6.27576C8.0381 6.3837 8.01514 6.49942 8.01514 6.61628C8.01514 6.73314 8.0381 6.84886 8.0827 6.9568C8.12731 7.06474 8.19268 7.16279 8.27509 7.24534L11.724 10.7074L8.27509 14.1695C8.10888 14.3363 8.01551 14.5626 8.01551 14.7986C8.01551 15.0345 8.10888 15.2608 8.27509 15.4276C8.44129 15.5945 8.66671 15.6882 8.90175 15.6882C9.1368 15.6882 9.36222 15.5945 9.52842 15.4276L13.6084 11.332C13.6908 11.2495 13.7562 11.1514 13.8008 11.0435C13.8454 10.9355 13.8684 10.8198 13.8684 10.703C13.8684 10.5861 13.8454 10.4704 13.8008 10.3624C13.7562 10.2545 13.6908 10.1564 13.6084 10.0739L9.52842 5.97829C9.19064 5.63923 8.62175 5.63923 8.27509 5.98722Z" fill="#0855C4")
              // CAMBIAR ESTA OPCIÓN POR OTRA CUANDO AMERITA
              article.pl-3.pr-2(v-if="flags.cvcAvailable")
                .g-flex.align-center.justify-space-between.cursor-pointer(@click="goCambioViaCobro()")
                  .g-flex.align-center
                    figure(style="width: 47px;")
                      img(src="../assets/new-home/img-tarjeta-credito.svg")
                    .ml-3
                      h3 Cambiar método de pago
                  svg(width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg")
                    path(d="M8.27509 5.98722C8.19268 6.06977 8.12731 6.16782 8.0827 6.27576C8.0381 6.3837 8.01514 6.49942 8.01514 6.61628C8.01514 6.73314 8.0381 6.84886 8.0827 6.9568C8.12731 7.06474 8.19268 7.16279 8.27509 7.24534L11.724 10.7074L8.27509 14.1695C8.10888 14.3363 8.01551 14.5626 8.01551 14.7986C8.01551 15.0345 8.10888 15.2608 8.27509 15.4276C8.44129 15.5945 8.66671 15.6882 8.90175 15.6882C9.1368 15.6882 9.36222 15.5945 9.52842 15.4276L13.6084 11.332C13.6908 11.2495 13.7562 11.1514 13.8008 11.0435C13.8454 10.9355 13.8684 10.8198 13.8684 10.703C13.8684 10.5861 13.8454 10.4704 13.8008 10.3624C13.7562 10.2545 13.6908 10.1564 13.6084 10.0739L9.52842 5.97829C9.19064 5.63923 8.62175 5.63923 8.27509 5.98722Z" fill="#0855C4")

              article.pl-3.pr-2(v-else-if="flags.isRentas")
                .g-flex.align-center.justify-space-between.cursor-pointer(@click="checkAndDownloadPDFRentas()")
                  .g-flex
                    figure(style="width: 47px;")
                      img(src="../assets/new-home/img-calendar.svg" style="margin-top: 7px;")
                    .ml-2
                      h3
                        span Cronograma de pago
                      p(v-if="!flags.rentaRVIAvailable" style="color: #40C2A6;") Podrás visualizar tus pagos al ingresar a tu póliza
                  svg(width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg")
                    path(d="M8.27509 5.98722C8.19268 6.06977 8.12731 6.16782 8.0827 6.27576C8.0381 6.3837 8.01514 6.49942 8.01514 6.61628C8.01514 6.73314 8.0381 6.84886 8.0827 6.9568C8.12731 7.06474 8.19268 7.16279 8.27509 7.24534L11.724 10.7074L8.27509 14.1695C8.10888 14.3363 8.01551 14.5626 8.01551 14.7986C8.01551 15.0345 8.10888 15.2608 8.27509 15.4276C8.44129 15.5945 8.66671 15.6882 8.90175 15.6882C9.1368 15.6882 9.36222 15.5945 9.52842 15.4276L13.6084 11.332C13.6908 11.2495 13.7562 11.1514 13.8008 11.0435C13.8454 10.9355 13.8684 10.8198 13.8684 10.703C13.8684 10.5861 13.8454 10.4704 13.8008 10.3624C13.7562 10.2545 13.6908 10.1564 13.6084 10.0739L9.52842 5.97829C9.19064 5.63923 8.62175 5.63923 8.27509 5.98722Z" fill="#0855C4")
              article.pl-3.pr-2(v-if="flags.loanAvailable")
                .g-flex.align-center.justify-space-between.cursor-pointer(@click="showChooseProductLoans()")
                  .g-flex
                    figure(style="width: 47px;")
                      img(src="../assets/new-home/small-billet.png" style="margin-top: 7px;")
                    .ml-2
                      h3 Tienes un préstamo
                      .d-flex
                        p Monto máximo:
                        p {{ amountMaxLoanInfo }}
                  svg(width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg")
                    path(d="M8.27509 5.98722C8.19268 6.06977 8.12731 6.16782 8.0827 6.27576C8.0381 6.3837 8.01514 6.49942 8.01514 6.61628C8.01514 6.73314 8.0381 6.84886 8.0827 6.9568C8.12731 7.06474 8.19268 7.16279 8.27509 7.24534L11.724 10.7074L8.27509 14.1695C8.10888 14.3363 8.01551 14.5626 8.01551 14.7986C8.01551 15.0345 8.10888 15.2608 8.27509 15.4276C8.44129 15.5945 8.66671 15.6882 8.90175 15.6882C9.1368 15.6882 9.36222 15.5945 9.52842 15.4276L13.6084 11.332C13.6908 11.2495 13.7562 11.1514 13.8008 11.0435C13.8454 10.9355 13.8684 10.8198 13.8684 10.703C13.8684 10.5861 13.8454 10.4704 13.8008 10.3624C13.7562 10.2545 13.6908 10.1564 13.6084 10.0739L9.52842 5.97829C9.19064 5.63923 8.62175 5.63923 8.27509 5.98722Z" fill="#0855C4")

          .inicio-panel-pagos.contactanos()
            h2 Contáctanos
            .inicio-panel-pagos-list
              article.pl-3.pr-2
                .g-flex.align-center.justify-space-between
                  .g-flex
                    figure(style="width: 37px;")
                      img(src="../assets/new-home/icon-chat.svg")
                    .ml-3
                      h3(style="font-size: 14px;") Ingresa a nuestra &nbsp;
                        a(style="color: #00A9FF;" :href="links.Home" target="_blank") web
                        br
                        | y conoce nuestros
                        br
                        | canales digitales
          // ESTA SECCIÓN ESTARA ACTIVA SIEMPRE PERO EL ESTILO VARIA
          //- div(v-if="!(flags.paymentsAvailable && flags.cvcAvailable && flags.loanAvailable)" :class="(flags.paymentsAvailable || flags.cvcAvailable || flags.loanAvailable) ? 'inicio-panel-contacto' : 'inicio-panel-contacto mt-4'" :style="(!flags.paymentsAvailable && !flags.cvcAvailable && !flags.loanAvailable) ? 'margin-left: 0' : ''")
            h2 Contáctanos
            article
              .g-flex(style="margin-top: 5px;" @click="trackGoverPhone()")
                figure
                  img(src="https://www.interseguro.pe/wp-content/uploads/2018/12/chat-icono.svg" )
                a(href="links.Chat" target="_blank") Chatea con nosotros
              .g-flex(style="margin-top: 5px;")
                p L. a V. de 9:00 a 18:00 hrs. <br>Sábados de 9:00 a 13:00 hrs.
              //- .g-flex
                figure
                  img(src="../assets/new-home/img-email.png")
                a(href="mailto:servicios@Interseguro.com.pe") servicios@Interseguro.com.pe
    .inicio-extra
      section(v-if="shouldShowViveMas")
        h2 Programa de beneficios
        article.benefit.d-flex.align-center.justify-center(@click="goToVivemas($event)", style="cursor: pointer;")
          figure.text-xs-center
            img(src="../assets/new-home/img-sorpresa.png")
          div
            h3 Vive más
            p Aquí encontrás asistencias y descuentos

      section(v-if="flags.prestamosVidaAvailable")
        h2 Préstamos
        article.benefit.d-flex.align-center.justify-center(@click="goPrestamoVida($event)", style="cursor: pointer; gap: 16px;")
          figure.text-xs-center
            img(src="../assets/prestamos-vida/flat-icons-money-transfer.svg" style="height: 65px;")
          div
            h3 Préstamo disponible
            p Solicita tu préstamo hoy con una TEA preferencial.

      section#formalities
        h2 Estado de mis solicitudes
        .inicio-extra-gray(v-if="requirements.length < 1")
          div
            figure
              img(src="../assets/new-home/time-tracking.png")
            p Aún no has realizado una solicitud
        CardTrackingSolicitudes(
          v-for="(req, index) in requirements.slice(0, 2)" :key="req.id"
          :title="req.title"
          :code="req.code"
          :percent="req.percent"
          :selected="req.selected"
          :status="req.status"
          :requirement="req.requirement"
          :home="true"
          :showInsuranceID="true"
          :newDesign="req.newDesign"
          @goToRequirement="() => goToRequirement(req)"
        )
        button.see-more(v-if="requirements.length > 2" @click.prevent="switchTrackingPop(true)") Ver más
        //- button Ver más
    //- More Insurance Modal
    //- dialog-more-insurances(v-if="$vuetify.breakpoint.smAndDown" :dialogMoreInsurances="dialogMoreInsurances")
    //- Contact us Modal
    //- dialog-contact-us(v-if="$vuetify.breakpoint.smAndDown" :dialogContactUs="dialogContactUs")
    //- Products for Loans
    v-dialog(v-if="flagConogramaPago" v-model="dialogChooseLoans" max-width="700px")
      v-card#choose-product-loans
        v-card-title.px-0.pt-4
          h2.omnesSemibold.text-xs-center Elige uno de tus productos
        v-card-text
          v-layout.mt-3(row wrap)
            v-flex(xs12 sm12 md3 lg3)
            v-flex(xs12 sm12 md6 lg6)
              v-select(:items='items.products' label="PRODUCTO" required v-model='form.product' @change="changePolicyData")
            v-flex(xs12 sm12 md3 lg3)
          v-layout.mt-4(row wrap)
            v-flex(xs12 sm12 md3 lg3)
            v-flex(xs12 sm12 md6 lg6)
              v-select(:items='items.policiy' label="PÓLIZA" required v-model='form.policy')
            v-flex(xs12 sm12 md3 lg3)
          v-layout.mt-3(row wrap)
            v-flex(xs12 sm12 md3 lg3)
            v-flex.choosenBtn.text-xs-center(xs12 sm12 md6 lg6)
              v-btn.omnesMedium(v-if="!onEnterLoan" block @click.native="goToLoans" :disabled="!(form.product && form.policy)") Ingresar
              v-btn#btnLogin(v-else disabled type='button')
                span INGRESANDO
                pulse-loader(:loading="onEnterLoan" :color="color" :size="size")
            v-flex(xs12 sm12 md3 lg3)
    //- LOADER PROCESS
    v-dialog(v-if="flagConogramaPago" v-model="loader" persistent width="300")
      v-card(color="primary" dark="")
        v-card-text
          | Cerrando Sesión...
          v-progress-linear.mb-0(indeterminate="" color="white")
    //- LOADER PROCESS
    v-dialog(v-if="loaderHome" v-model="loaderHome" persistent width="300")
      v-card(color="primary" dark="")
        v-card-text
          | Consultando información...
          v-progress-linear.mb-0(indeterminate="" color="white")
    //- LOADER PROCESS
    v-dialog(v-if="flagConogramaPago" v-model="validateLoader" persistent width="300")
      v-card(color="primary" dark="")
        v-card-text
          | Validando información...
          v-progress-linear.mb-0(indeterminate="" color="white")
    //- MODAL PRESTAMOS IF APPLICABLE
    v-dialog(v-if="flagConogramaPago" v-model="showLoansInformation" persistent width="363" style="text-align:center")
      v-card
        v-card-text
          .icon-close-info-loans(style="overflow:hidden;cursor:pointer")
            img(:src="icons.closeLoanInformation" alt="iconCloseLoanInformation" style="float:right" width="28px" @click="closeLoansInformation")
          .icon-info-loans(style="text-align:center")
            img(:src="icons.loanInformation" alt="iconLoanInformation")
          .text-info-loans
            h2(style="color:#0855C4;text-align:center;font-weight:normal;margin:8px 0;font-size:18px;line-height:1.3")
              | Solicita un préstamo
              br
              | desde casa
            p(style="color: #535d66;text-align:center;font-size:16px")
              | Si tienes alguna urgencia o necesidad, tienes&nbsp;
              strong(style="text-wrap:nowrap") hasta {{ amountMaxLoanInfo }}&nbsp;
              | de efectivo disponible al instante para tu póliza {{ policyWhoHaveMaxLoan }}.
            .btn-text-info-loans
              v-btn.omnesSemibold(@click.native="goToCotizar") Cotizar
    //- MODAL ALERTA POLIZAS SOAT POR VENCER
    v-dialog(v-if="flagConogramaPago" v-model="showExpiringPolizasSOAT", persistent, width="380")
      v-card.card_expired-soat
        v-card-text#modal-expired-soat
          .icon-info-soat-expiring(style="text-align:center")
            img(:src="icons.personajeComputador" alt="iconAlert")
          .text-info-loans
            h2(style="color:#0855C4;text-align:center;font-weight:normal;margin:8px 0;font-size: 18px;line-height:1.3")
              | ¡Tu SOAT está por vencer!
            p(style="color: #535d66;text-align:center;font-size:16px")
              | Recuerda que puedes renovar para
              br
              | prevenir cualquier siniestro con tu vehículo.
              //- br
              //- | Tienes los siguientes SOAT por vencer, con placa:
              //- ul.list-soat-expiring
                li(v-for="(placa, index) in placasSOATExpiring")
                  p
                    strong {{placa}}
            .btn-text-info-soat-expiring
              v-btn.omnesSemibold(@click="showExpiringPolizasSOAT = false") ¡Quiero renovar!
  popup-alerta(
    @closeAlertPopup="closeAlerPopupMethod"
    :openPopup="alertPopupData.flag"
    :image="alertPopupData.icon"
    :title="alertPopupData.title"
    :message="alertPopupData.message"
    :messageButton="alertPopupData.messageButton"
    :buttonClose = "alertPopupData.buttonClose"
    :imgWidth="'130'"
    )
  PopupSorteo(
    @closeAlertPopup="closeAlerPopupMethod"
    :openPopup="popupSorteo.flag"
    :image="popupSorteo.icon"
    :title="popupSorteo.title"
    :message="popupSorteo.message"
    :messageButton="popupSorteo.messageButton"
    :linkButton="popupSorteo.link"
    :buttonClose="popupSorteo.buttonClose"
    )
  PopupTrackingSolicitudes(
    :openPopup="flagTrackRequirements"
    :requirements="requirements"
    @closeAlertPopup="switchTrackingPop(false)"
  )
  //- Piloto de préstamos de vida
  PopupPrestamosVida(
    @closeAlertPopup="closeAlerPopupMethod"
    :openPopup="popupPrestamosVida.flag"
  )
  PopupSolicitudEnCurso(
    :openPopup="showModalSolicitudEnCurso"
    @close="showModalSolicitudEnCurso = false"
  )
</template>

<script>
import quoter from './../interfaces/quoter'
import FormAnnuity from '@/components/FormAnnuity'
import FormMasivo from '@/components/FormMasivo'
import FormGuaranteedEducation from '@/components/FormGuaranteedEducation'
import DialogMoreInsurances from '@/components/modals/DialogMoreInsurances'
import DialogContactUs from '@/components/modals/DialogContactUs'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { mapActions, mapGetters } from 'vuex'
import imgS1 from '@/assets/products/seguro-vehicular.svg'
import imgS2 from '@/assets/products/educacion-garantizada.svg'
import imgS3 from '@/assets/products/vida.svg'
import imgS4 from '@/assets/products/soat.svg'
import axios from 'axios'
import Amplitude from './../interfaces/amplitudeData'
import Links from './../interfaces/links'
import Rules from './../interfaces/transactsRestrictions'
import Transacts from './../interfaces/transacts'
import { getHashIS } from '../interfaces/sha256'
import PopupAlertMessage from '../components/PopupAlertMessage.vue'
import PopupSorteo from '@/components/modals/PopupSorteo.vue'
import PopupPrestamosVida from '@/components/modals/prestamos-vida/PopupPrestamosVida.vue'
import PopupSolicitudEnCurso from '@/components/modals/prestamos-vida/PopupSolicitudEnCurso.vue'
import moment from 'moment'
import CardTrackingSolicitudes from '@/components/mis-seguros/CardTrackingSolicitudes.vue'
import PopupTrackingSolicitudes from '@/components/modals/PopupTrackingSolicitudes.vue'
import Functionalities from '../interfaces/functionalities'
import trackingMixin from '../mixins/trackingMixin'

export default {
  mixins: [trackingMixin],
  data () {
    return {
      links: Links,
      color: '#1745A8',
      size: '11px',
      availableForFormalities: false,
      onEnterLoan: false,
      dialogChooseLoans: false,
      loader: false,
      loaderHome: false,
      validateLoader: false,
      showLoansInformation: false,
      showExpiringPolizasSOAT: false,
      amountMaxLoanInfo: '',
      policyWhoHaveMaxLoan: '',
      dialogContactUs: false,
      placasSOATExpiring: [],
      policyAvailableForLoan: [],
      requirements: [],
      listSeguros: [],
      paymentsWait: true,
      paymentsPendings: '',
      column: null,
      inline: null,
      flags: {
        paymentsAvailable: false,
        cvcAvailable: false,
        loanAvailable: false,
        moreProducts: false,
        rentaRVIAvailable: false,
        isRentas: false,
        isOnlySoat: false,
        showNextIcon: false,
        showAnnuity: false,
        showGuaranteed: false,
        showMasivo: false,
        prestamosVidaAvailable: false
      },
      files: {
        cronogramaRVI: require('./../assets/downloable/calendario_pagos_RRVV_2026.pdf'),
        cronogramaRPP: require('./../assets/downloable/calendario_pagos_RPP_2026.pdf')
      },
      icons: {
        closeLoanInformation: require('./../assets/icons/icon-close-prestamos-modal.svg'),
        loanInformation: require('./../assets/icons/icon-prestamos-modal.svg'),
        alert: require('./../assets/iconsv5/icon-alerta.svg'),
        personajeComputador: require('@/assets/characters/informa.svg')
      },
      banners: {
        pagoAuto: {
          img: require('./../assets/new-home/img-banner-1.png'),
          title: '¡Afíliate al débito automático!',
          parraf: 'Evita salir de casa y ten tus pagos al día.',
          button: 'Afiliarme',
          option: '/cambio-via-cobro'
        },
        masSeguros: {
          img: require('./../assets/new-home/img-banner-2.png'),
          title: '¡Tenemos más seguros para ti!',
          parraf: 'Revisa todas las opciones que tenemos.',
          button: 'Ver más'
        },
        prestamos: {
          img: require('./../assets/new-home/img-banner-3.png'),
          title: '¡Tienes un préstamo disponible!',
          parraf: 'Úsalo para lo que necesites.',
          button: 'Ver más',
          option: '/prestamos/operaciones'
        },
        prepagos: {
          img: require('./../assets/new-home/img-banner-3.png'),
          title: '¡Puedes prepagar tus préstamos!',
          parraf: 'Prepaga para tener un mayor beneficio.',
          button: 'Ver más',
          option: '/prepago/cotizar'
        },
        pagoRealizado: {
          img: require('./../assets/new-home/banners/banner_vida_vehi_2.svg'),
          title: '¡Ahora puedes pagar tu seguro por adelantado!',
          parraf: 'Puedes estar al día pagando antes de tiempo.',
          button: 'Ingresa aquí',
          option: '/pago-de-cuotas'
        },
        cronogramaRenta: {
          img: require('./../assets/new-home/banners/banner_rentas_2.svg'),
          title: '¡Revisa el cronograma de pagos de tu pensión aquí!',
          parraf: 'Revisa los días que cobrarás en el año.',
          button: 'Ingresa aquí'
        },
        prestamosVida: {
          img: require('./../assets/prestamos-vida/img-banner-prestamos-vida.svg'),
          title: '¡Préstamo disponible!',
          parraf: 'Aprovecha la TEA preferencial',
          button: 'Solicitar préstamo',
          option: '/prestamos-vida'
        }
      },
      selected: {
        guaranteed: null,
        annuity: null,
        masivo: null
      },
      mainBanner: {
        img: '',
        title: '',
        parraf: '',
        button: '',
        option: null
      },
      items: {
        products: [{ value: null, text: 'Selecciona un producto' }],
        policiy: [{ value: null, text: 'Selecciona tu póliza' }]
      },
      form: {
        product: null,
        policy: null
      },
      amplitude: {
        events: {
          funcionalitySelected: 'Funcionalidad Seleccionada',
          loanIntention: 'Intención de Préstamo',
          consultedInsurance: 'Seguro Consultado'
        },
        properties: {
          myInsurance: 'Mis Seguros',
          profile: 'Mis Datos',
          vivemas: 'Vive+',
          loans: 'Prestamos',
          formalities: 'Atención al Cliente',
          moreInsurance: 'Mas seguros para ti',
          cvc: 'Cambio Vida de Cobro',
          emergency: 'Emergencias',
          contactUs: 'Contáctanos'
        }
      },
      alertPopupData: {
        flag: false
      },
      popupSorteo: {
        flag: false
      },
      flagConogramaPago: true,
      tipoPensionRVI: ['JUBILACIÓN', 'INVALIDEZ PARCIAL', 'INVALIDEZ TOTAL', 'JUBILACIÓN ANTICIPADA'],
      flagTrackRequirements: false,
      popupPrestamosVida: {
        flag: false,
        data: {}
      },
      hasSeenPopup: false,
      showModalSolicitudEnCurso: false,
    }
  },
  watch: {
    extraInfo(val) {
      this.popupPrestamosVida.data = val;
    },
  },
  methods: {
    ...mapActions('user', ['getPolizas', 'getInformacionPrestamo', 'getEstadoPrestamo', 'setEstadoPrestamo', 'getUserInfo', 'getPrestamosVidaDisponibilidad']),
    ...mapActions('requirements', ['getAllRequirementsPerPolicy']),
    ...mapActions('payments', ['getPaymentQuotes']),
    ...mapActions('event', ['eventLog']),
    openNewWindow (url) {
      window.dataLayer = window.dataLayer || []
      if (url.includes('ayuda')) {
        // EVENT TRACK - GA
        this.$gtm.trackEvent({
          event: 'virtualPageView',
          pageTitle: 'Emergencias',
          pageUrl: '/zonaprivada/emergencias'
        })
        // TRACK EVENT - AMPLITUDE
        this.$amplitude.getInstance()
          .logEvent(
            this.amplitude.events.funcionalitySelected,
            {
              'Funcionalidad': this.amplitude.properties.emergency
            }
          )
      }
      window.open(url, '_blank')
    },
    closeLoansInformation () {
      this.showLoansInformation = false


    this.$gtm.trackEvent({
        "event":"select_button",
        "Nombre Sección":"Zona Segura",
        "TipoElemento":"Botón",
        "TipoAccion":"Popup solicita préstamo - cerrar",
        "CTA":"Cerrar"
    })
    },
    goToCotizar () {
      this.showLoansInformation = false
      this.showChooseProductLoans(false)
      
      this.$gtm.trackEvent({
        "event":"select_button",
        "Nombre Sección":"Zona Segura",
        "TipoElemento":"Botón",
        "TipoAccion":"Popup solicita préstamo - cotizar",
        "CTA":"Cotizar"
    })

    },
    goContactUs () {
      // TRACK EVENT - AMPLITUDE
      this.$amplitude.getInstance()
        .logEvent(
          this.amplitude.events.funcionalitySelected,
          {
            'Funcionalidad': this.amplitude.properties.contactUs
          }
        )
      this.dialogContactUs = true
    },
    showOperations () {
      // TRACK EVENT - AMPLITUDE
      this.$amplitude.getInstance()
        .logEvent(
          this.amplitude.events.funcionalitySelected,
          {
            'Funcionalidad': this.amplitude.properties.loans
          }
        )
      this.$router.push('/prestamos/operaciones')
    },
    makeMainRequeriment (mainBanner) {
      if (mainBanner && mainBanner.option === '/prestamos-vida') {
        if (this.tieneSolicitudPrestamoVidaEnEvaluacion) {
          this.showModalSolicitudEnCurso = true
          return
        }
        this.$router.push(mainBanner.option)
        return
      }
      if (mainBanner && mainBanner.option) {
        // Registrar evento GTM para banner de préstamos
        if (mainBanner.option === '/prestamos/operaciones') {
          this.$gtm.trackEvent({
            event: 'select_button',
            'Nombre Sección': 'Zona Segura',
            TipoElemento: 'Botón',
            TipoAccion: 'Home - cards destacado - préstamos',
            CTA: 'Tienes un préstamo disponible - ver más'
          })
        }
        this.$router.push(mainBanner.option)
      } else if (this.flags.cvcAvailable) {
        this.$router.push('/cambio-via-cobro')
      } else if (this.flags.loanAvailable) {
        this.$router.push('/prestamos/operaciones')
      } else if (this.flags.rentaRVIAvailable) {
        this.checkAndDownloadPDFRentas()
      } else if (this.flags.paymentsAvailable) {
        this.$router.push('/pago-de-cuotas')
      } else if (this.flags.moreProducts) {
        this.$router.push('/mas-seguros')
      } else {
        this.$router.push('/inicio')
      }
    },
    showChooseProductLoans (registerEvent = true) {
      const self = this
      this.showLoansInformation = false
      if (!Functionalities.isAvailable(Functionalities.rentas.PRESTAMOS, self.functionsRules, self)) {
        return
      }
      
      if(registerEvent) {
      // Registrar evento GTM al hacer clic en card "Tienes un préstamo"
      this.$gtm.trackEvent({
        event: 'select_button',
        'Nombre Sección': 'Zona Segura',
        TipoElemento: 'Botón',
        TipoAccion: 'Home - cards - préstamos',
        CTA: 'Tienes un préstamo'
      })
      }

      
      let polizasAvaliable = null
      // let finalPolizasAvaliable = []
      let axiosRequests = []
      self.validateLoader = true
      if (self.polizasInfo !== null) {
        polizasAvaliable = self.polizasInfo.filter(f => {
          return f.ramo === 'RRVV' && (f.codigoProducto === 'RPP' || f.codigoProducto === 'IFP') && parseInt(f.periodoGarantizado) > 0 && f.celular !== ''
        })
        if (polizasAvaliable.length > 0) {
          for (let i = 0; i < polizasAvaliable.length; i++) {
            axiosRequests.push(self.getInformacionPrestamo({poliza: polizasAvaliable[i].numeroPoliza, vista: 'HomePop'}))
          }
          axios.all(axiosRequests).then(function (results) {
            self.validateLoader = false
            results.forEach(function (res) {
              if (res.data && (res.data.ingresoMensual > 1 || (res.data.devolucion.porcentaje && res.data.devolucionActual > res.data.devolucion.monto / 2))) {
                //! OBTAIN GENERAL DATA FOR POLIZA
                let infoPoliza = self.polizasInfo.filter(f => { return f.numeroPoliza === res.data.numeroPoliza })[0]
                //! POPULATE DATA FOR POLIZA AVAILABLE
                self.policyAvailableForLoan.push({
                  numeroPoliza: infoPoliza.numeroPoliza,
                  producto: infoPoliza.producto,
                  codigoProducto: infoPoliza.codigoProducto,
                  ramo: infoPoliza.ramo,
                  periodoGarantizado: infoPoliza.periodoGarantizado,
                  celular: infoPoliza.celular,
                  ingresoMensual: res.data.ingresoMensual
                })
              }
            })
            if (self.policyAvailableForLoan.length > 0) {
              self.$gtm.trackEvent({ event: 'Elige tu producto' })
              self.dialogChooseLoans = true
              self.policyAvailableForLoan.map(product => {
                self.items.products.push({ value: product.codigoProducto, text: product.producto })
              })
            } else {
              self.$swal({
                title: 'Atención',
                text: 'Ya no puedes pedir más préstamos porque has llegado al límite de tu renta mensual. Si deseas más préstamos, puedes prepagarlos.',
                confirmButtonText: 'Entendido'
              }).then((result) => {
                self.$store.state.user.haveLoanRequested = null
              })
            }
          })
        } else {
          self.validateLoader = false
          self.$swal({
            title: 'Estimado Cliente',
            text: 'Le comunicamos que debe tener registrado su número de celular con nosotros. Por favor, comunicarse con nuestro Servicio de Atención al Cliente para registrar su número de celular.',
            confirmButtonText: 'Entendido'
          })
        }
      } else {
        self.validateLoader = false
        self.$swal({
          title: 'Estimado Cliente',
          text: 'Estamos validando su información. Puedes ingresar a Mis Seguros para ver el estado del proceso.',
          confirmButtonText: 'Entendido'
        })
      }
    },
    changePolicyData () {
      if (this.form.product) {
        this.items.policiy = this.policyAvailableForLoan.filter(f => {
          return f.codigoProducto === this.form.product && f.ramo === 'RRVV' && parseInt(f.periodoGarantizado) > 0 && f.celular !== ''
        }).map(r => {
          return { value: r.numeroPoliza, text: r.numeroPoliza }
        })
      } else {
        this.items.policiy = []
      }
    },
    goToLoans () {
      let self = this
      self.onEnterLoan = true
      self.getEstadoPrestamo({ codigoUsuario: self.userInfo.codigoUsuario }).then(res => {
        if (!res.data.procesandoPrestamo) {
          self.setEstadoPrestamo({ codigoUsuario: self.userInfo.codigoUsuario, flag: true })
            .then(res => {
              if (res.data.procesandoPrestamo !== 'already') {
                self.onEnterLoan = false
                localStorage.setItem('selPol', self.form.policy)
                // - TRACK EVENT - GA
                /*
                self.$gtm.trackEvent({
                  event: 'Ingresar a prestamos',
                  producto_prestamo: self.form.product,
                  poliza: self.form.policy
                })
                */
                // TRACK EVENT - AMPLITUDE
                self.$amplitude.getInstance()
                  .logEvent(
                    this.amplitude.events.funcionalitySelected,
                    {
                      'Funcionalidad': this.amplitude.properties.loans
                    }
                  )
                // TRACK EVENT - AMPLITUDE
                self.$amplitude.getInstance()
                  .logEvent(
                    self.amplitude.events.loanIntention,
                    {
                      'Producto': self.form.product,
                      'Poliza': self.form.policy,
                      'Tipo de intención': 'Préstamo RPP-IFP'
                    }
                  )
                self.$router.push('/prestamos/paso/cotizar')
              } else {
                self.onEnterLoan = false
                self.dialogChooseLoans = false
                self.trackValidationPopup('Tienes un prestamo en cotizacion')
                self.$swal({
                  title: 'Atención',
                  text: 'Tienes un préstamo en cotización. Si deseas empezar de nuevo, cierra sesión en todos los dispositivos y vuelve a intentarlo.',
                  confirmButtonText: 'Entendido'
                }).then((result) => {
                  self.$store.state.user.haveLoanRequested = null
                })
              }
            })
        } else {
          self.onEnterLoan = false
          self.dialogChooseLoans = false
          self.trackValidationPopup('Tienes un prestamo en cotizacion')
          self.$swal({
            title: 'Atención',
            text: 'Tienes un préstamo en cotización. Si deseas empezar uno nuevo, cierra sesión en todos los dispositivos y vuelve a intentarlo.',
            confirmButtonText: 'Entendido'
          }).then((result) => {
            self.$store.state.user.haveLoanRequested = null
          })
        }
      })
    },
    goCambioViaCobro () {
      if (this.polizasInfo !== null) {
        localStorage.removeItem('cvcSuccess')
        // TRACK EVENT - AMPLITUDE
        this.$amplitude.getInstance()
          .logEvent(
            this.amplitude.events.funcionalitySelected,
            {
              'Funcionalidad': this.amplitude.properties.cvc
            }
          )
        // EVENT TRACK - Universal Analytics
        this.$gtm.trackEvent({
          event: 'virtualEvent',
          category: 'Zona Segura',
          action: 'Home - Cambio vía de cobro',
          label: 'Seleccionar botón - Cambio vía de cobro'
        })
        // EVENT TRACK - GA4
        this.$gtm.trackEvent({
          event: 'select_button',
          'Nombre Sección': 'Zona Segura',
          TipoElemento: 'Botón',
          TipoAccion: 'Home - Cambio vía de cobro',
          CTA: 'Seleccionar botón - Cambio vía de cobro'
        })
        this.$router.push('/cambio-via-cobro')
      } else {
        this.$swal({
          title: 'Estimado Cliente',
          text: 'Estamos validando su información. Por favor, vuelva a ingresar a la opción.',
          confirmButtonText: 'Entendido'
        })
      }
    },
    goToVivemas () {
      // TRACK EVENT - AMPLITUDE
      this.$amplitude.getInstance()
        .logEvent(
          this.amplitude.events.funcionalitySelected,
          {
            'Funcionalidad': this.amplitude.properties.vivemas
          }
        )
      // EVENT TRACK - Universal Analytics
      this.$gtm.trackEvent({
        event: 'virtualEvent',
        category: 'Zona Segura',
        action: 'Home - Vive más',
        label: 'Seleccionar botón - Vive más'
      })
      // EVENT TRACK - GA4
      this.$gtm.trackEvent({
        event: 'select_button',
        'Nombre Sección': 'Zona Segura',
        TipoElemento: 'Botón',
        TipoAccion: 'Home - Vive más',
        CTA: 'Seleccionar botón - Vive más'
      })
      this.$router.push('/vivemas')
    },
    goPagoCuotas () {
      if (this.polizasInfo !== null) {
        localStorage.removeItem('paymentSuccess')
        // TRACK EVENT - AMPLITUDE
        this.$amplitude.getInstance()
          .logEvent(
            Amplitude.Home.events.funcionalitySelected,
            {
              'Funcionalidad': Amplitude.Home.properties.pagoCuotas
            }
          )
        // EVENT TRACK - Universal Analytics
        this.$gtm.trackEvent({
          event: 'virtualEvent',
          category: 'Zona Segura',
          action: 'Home - Mis pagos',
          label: 'Seleccionar botón - Mis pagos'
        })
        // EVENT TRACK - GA4
        this.$gtm.trackEvent({
          event: 'select_button',
          'Nombre Sección': 'Zona Segura',
          TipoElemento: 'Botón',
          TipoAccion: 'Home - Mis pagos',
          CTA: 'Seleccionar botón - Mis pagos'
        })
        this.$router.push('/pago-de-cuotas')
      } else {
        this.$swal({
          title: 'Estimado Cliente',
          text: 'Estamos validando su información. Por favor, vuelva a ingresar a la opción.',
          confirmButtonText: 'Entendido'
        })
      }
    },
    goPrestamoVida (evt) {

      this.$gtm.trackEvent({
        event: 'virtualEvent',
        category: 'Zona Segura',
        action: 'Seleccionar menú - Prestamo Vida',
        label: 'Prestamo Vida'
      })

      this.$gtm.trackEvent({
        event: 'select_button',
        'Nombre Sección': 'Zona Segura',
        TipoElemento: 'Botón',
        TipoAccion: 'Seleccionar menú - Prestamo Vida',
        CTA: 'Prestamo Vida'
      })

      var allElements = document.querySelectorAll('.inicio-main-content nav.menu a')

      for (var i = 0; i < allElements.length; i++) {
        allElements[i].classList.remove('active-menu')
      }

      evt.currentTarget.classList.add('active-menu')

      if (this.tieneSolicitudPrestamoVidaEnEvaluacion) {
        this.showModalSolicitudEnCurso = true
        return
      }

      if (this.polizasInfo !== null) {
        if (this.$vuetify.breakpoint.smAndDown) {
          this.showMenu = !this.showMenu
        }

        if (this.$route.path !== '/prestamos-vida') {
          this.$router.push('/prestamos-vida')
        }
      } else {
        this.$swal({
          title: 'Estimado Cliente',
          text: 'Estamos validando su información. Por favor, vuelva a ingresar a la opción.',
          type: 'warning',
          confirmButtonText: 'Entendido'
        })
      }
    },
    checkAndDownloadPDFRentas () {
      for (let index = 0; index < this.polizasInfo.length; index++) {
        let poliza = this.polizasInfo[index]
        if (['IFP', 'RPP'].includes(poliza.codigoProducto) || this.tipoPensionRVI.includes(poliza.tipoPension)) {
          let currentDate = new Date().getFullYear()
          const file = this.tipoPensionRVI.includes(poliza.tipoPension) ? 'Calendario_Pagos_RRVV_' + currentDate + '.pdf' : 'Calendario_Pagos_RPP_' + currentDate + '.pdf'
          const url = this.tipoPensionRVI.includes(poliza.tipoPension) ? this.files.cronogramaRVI : this.files.cronogramaRPP
          const eventData = {
            categoria: 'Documentos',
            nombre: 'Cronograma de pagos',
            datos: {
              numeroPoliza: poliza.numeroPoliza,
              producto: poliza.codigoProducto,
              dispositivo: 'desktop',
              seccion: 'Home',
              archivo: file,
              url
            }
          }
          let link = document.createElement('a')
          link.href = url
          link.download = file
          link.target = '_blank'
          link.click()
          this.eventLog(eventData)
          return
        }
      }
    },
    display (poliza, action) {
      // TRACK EVENT - AMPLITUDE
      var productoConsultado = ''
      if (poliza.oriProducto === null) {
        if (poliza.modalidad === null) {
          productoConsultado = poliza.producto
        } else {
          productoConsultado = poliza.modalidad
        }
      } else {
        productoConsultado = poliza.oriProducto
      }
      this.$amplitude.getInstance()
        .logEvent(
          this.amplitude.events.consultedInsurance,
          {
            'Producto Consultado': productoConsultado
          }
        )
      if (poliza.ramo === 'Vida') {
        this.selected.guaranteed = poliza
        // this.flags.showGuaranteed = true

        if (poliza.oriProducto === 'Plan Garantizado' || poliza.oriProducto === 'Educación Garantizada' || poliza.nombreProducto === 'EDUCGARANTIZADAPLUSNEW' || poliza.nombreProducto === 'EDUCACIONGARANTIZADAPLUS') {
          // EVENT TRACK  Universal Analytics
          this.$gtm.trackEvent({
            'event': 'virtualEvent',
            'category': 'Zona Segura',
            'action': 'Home - Mis Seguros',
            'label': 'Seleccionar card - Plan Garantizado'
          })
          // EVENT TRACK  GA4
          this.$gtm.trackEvent({
            'event': 'select_product',
            'Nombre Sección': 'Zona Segura',
            'TipoElemento': 'Card',
            'TipoAccion': 'Home - Mis Seguros',
            'CTA': 'Seleccionar card - Plan Garantizado'
          })

          this.$router.push({
            name: 'PlanGarantizado',
            params: {
              infoPoliza: this.selected.guaranteed,
              infoUser: {
                apPaterno: this.userInfo.apellidoPaternoUsuario,
                apMaterno: this.userInfo.apellidoMaternoUsuario,
                nombre: this.userInfo.nombreUsuario,
                tipoDocumento: this.basicInfo.tipoDocumento,
                numeroDocumento: this.basicInfo.numeroDocumento,
                fechaNacimiento: this.basicInfo.fechaNacimiento,
                telefono: this.basicInfo.telefono,
                celular: this.basicInfo.celular,
                correo: this.basicInfo.correo
              },
              action
            }
          })
        } else if (poliza.nombreProducto === 'VIDAFREE') {
          this.$router.push({
            name: 'VidaFree',
            params: {
              infoPoliza: this.selected.guaranteed,
              infoUser: {
                apPaterno: this.userInfo.apellidoPaternoUsuario,
                apMaterno: this.userInfo.apellidoMaternoUsuario,
                nombre: this.userInfo.nombreUsuario,
                tipoDocumento: this.basicInfo.tipoDocumento,
                numeroDocumento: this.basicInfo.numeroDocumento,
                fechaNacimiento: this.basicInfo.fechaNacimiento,
                telefono: this.basicInfo.telefono,
                celular: this.basicInfo.celular,
                correo: this.basicInfo.correo
              },
              action
            }
          })
        } else if ((poliza.nombreProducto || '').includes('VIDACASH')) {
          this.$router.push({
            name: 'VidaCash',
            params: {
              infoPoliza: this.selected.guaranteed,
              infoUser: {
                apPaterno: this.userInfo.apellidoPaternoUsuario,
                apMaterno: this.userInfo.apellidoMaternoUsuario,
                nombre: this.userInfo.nombreUsuario,
                tipoDocumento: this.basicInfo.tipoDocumento,
                numeroDocumento: this.basicInfo.numeroDocumento,
                fechaNacimiento: this.basicInfo.fechaNacimiento,
                telefono: this.basicInfo.telefono,
                celular: this.basicInfo.celular,
                correo: this.basicInfo.correo
              },
              action
            }
          })
        } else if (poliza.producto.toLowerCase() === Transacts.products.RUMBO || (poliza.oriProducto || '').toLowerCase() === Transacts.products.RUMBO || (poliza.nombreProducto || '').toLowerCase() === Transacts.products.RUMBO) {
          // EVENT TRACK  Universal Analytics
          this.$gtm.trackEvent({
            'event': 'virtualEvent',
            'category': 'Zona Segura',
            'action': 'Home - Mis Seguros',
            'label': 'Seleccionar card - Rumbo'
          })
          // EVENT TRACK  GA4
          this.$gtm.trackEvent({
            'event': 'select_product',
            'Nombre Sección': 'Zona Segura',
            'TipoElemento': 'Card',
            'TipoAccion': 'Home - Mis Seguros',
            'CTA': 'Seleccionar card - Rumbo'
          })

          this.$router.push({
            name: 'Rumbo',
            params: {
              infoPoliza: this.selected.guaranteed,
              infoUser: {
                apPaterno: this.userInfo.apellidoPaternoUsuario,
                apMaterno: this.userInfo.apellidoMaternoUsuario,
                nombre: this.userInfo.nombreUsuario,
                tipoDocumento: this.basicInfo.tipoDocumento,
                numeroDocumento: this.basicInfo.numeroDocumento,
                fechaNacimiento: this.basicInfo.fechaNacimiento,
                telefono: this.basicInfo.telefono,
                celular: this.basicInfo.celular,
                correo: this.basicInfo.correo
              },
              action
            }
          })
        } else {
          this.flags.showGuaranteed = true
        }
      } else if ((poliza.ramo === 'RRVV' && poliza.codigoProducto !== 'RPP' && poliza.codigoProducto !== 'IFP') || (poliza.ramo === 'RRVV' && (poliza.codigoProducto === 'RPP' || poliza.codigoProducto === 'IFP'))) {
        this.selected.annuity = poliza
        this.flags.showAnnuity = true
      } else if (poliza.ramo !== 'Masivo') {
        this.$swal({
          title: '¡Atención!',
          text: 'Estamos trabajando para que puedas realizar más operaciones. Pronto te enterarás de más novedades.',
          confirmButtonText: 'Entendido'
        })
      } else if (poliza.ramo === 'Masivo' && (poliza.oriProducto === 'SEGUROVEHICULAR' || poliza.oriProducto === 'SEGUROVEHICULARMODULAR' || poliza.oriProducto === 'SOAT')) {
        this.selected.masivo = poliza
        this.flags.showMasivo = true
      } else if (poliza.ramo === '') {
        this.selected.guaranteed = poliza
        this.flags.showGuaranteed = true
      }
    },
    getPaymentsPendings (polizasVida) {
      let self = this
      const policies = polizasVida.filter(Rules.QuotesPayment.filterPoliciesPaymentAvailable)
      if (Rules.QuotesPayment.isPaymentsAvailable(policies)) {
        self.flags.paymentsAvailable = true
        self.getPaymentQuotes({ policies: policies.map(f => f.numeroPoliza) })
          .then(res => {
            if (res.status === 200 && res.data.codigoRespuesta === '01') {
              let polizasDisponibles = []
              polizasVida.forEach(item => {
                let poliza = {}
                let info = res.data.policies[item.numeroPoliza]
                poliza.policyNumber = item.numeroPoliza
                poliza.name = item.producto
                if (info && info !== null) {
                  poliza.pendingQuotes = 0 // info.pago.cuotas.filter(c => c.tipo.toLowerCase() === 'vencida').length
                  poliza.info = info
                  let cuotas = []
                  for (let cuota of info.pago.cuotas) {
                    let found = false
                    for (let i = 0; i < cuotas.length; i++) {
                      if (cuota.mes === cuotas[i].mes) {
                        found = true
                        cuotas[i].monto += cuota.monto
                        cuotas[i].rows.push(cuota)
                      }
                    }
                    if (!found) {
                      cuotas.push({ monto: cuota.monto, mes: cuota.mes, tipo: cuota.tipo, selected: false, rows: [cuota] })
                      poliza.pendingQuotes += (cuota.tipo.toLowerCase() === 'vencida') ? 1 : 0
                    }
                  }
                  poliza.cuotas = cuotas
                  polizasDisponibles.push(poliza)
                }
              })
              if (polizasDisponibles.length > 0) {
                self.paymentsWait = false
                self.paymentsPendings = ''
                /* self.cuotasPendientes = 0
                if (polizasDisponibles.filter(x => {
                  self.cuotasPendientes = self.cuotasPendientes < x.PendingQuotes ? x.PendingQuotes : self.cuotasPendientes
                  return x.pendingQuotes
                }).length > 0) */
                if (polizasDisponibles.filter(x => x.pendingQuotes).length > 0) {
                  self.paymentsPendings = 'Tienes pagos pendientes de tus seguros. Págalos aquí.'
                } else {
                  self.paymentsPendings = 'Estás al día en tus pagos. Puedes adelantar cuotas.'
                }
              }
            }
          })
          .catch(() => {
            self.loader2 = false
          })
      }
    },
    afterLoadPolizas (polizasInput) {
      let self = this
      this.flags.showNextIcon = polizasInput.length > 3
      let polizasRenta = polizasInput.filter(f => {
        return f.ramo === 'RRVV' && (f.codigoProducto === 'RPP' || f.codigoProducto === 'IFP') && parseInt(f.periodoGarantizado) > 0 && f.celular !== ''
      })
      let polizaRentaRVI = polizasInput.filter(f => {
        return f.ramo === 'RRVV' && f.codigoProducto === 'RVI'
      })
      let polizasVida = polizasInput.filter(f => { return f.ramo === 'Vida' || (f.oriProducto !== null && f.oriProducto.includes('VEHICULAR')) })
      // POPULATE PRODUCTS
      if (Rules.QuotesPayment.isPaymentsAvailable(polizasVida)) {
        self.$root.$emit('isAvailableForMakePayments', {})
        self.flags.paymentsAvailable = true
      }
      for (let index = 0; index < polizasInput.length; index++) {
        if (polizasInput[index].producto.toLowerCase() === 'seguro vehicular' || (polizasInput[index].oriProducto != null && polizasInput[index].oriProducto.toLowerCase() === 'segurovehicular')) {
          self.listSeguros.push({
            title: 'Seguro Vehicular',
            img: imgS1,
            txt1A: 'N° de placa:',
            txt1B: polizasInput[index].placa,
            txt2A: 'Marca:',
            txt2B: polizasInput[index].marca,
            policy: polizasInput[index],
            notiText: 'Es la placa que está indicada en la póliza.',
            noti: false
          })
        } else if (polizasInput[index].producto.toLowerCase().includes('soat')) {
          self.listSeguros.push({
            title: 'SOAT',
            img: imgS4,
            txt1A: 'N° de placa:',
            txt1B: polizasInput[index].placa,
            txt2A: 'Marca:',
            txt2B: polizasInput[index].marca,
            policy: polizasInput[index],
            notiText: 'Es la placa que está indicada en la póliza.',
            noti: false
          })
        } else if (polizasInput[index].producto.toLowerCase() === Transacts.products.RUMBO || (polizasInput[index].oriProducto != null && polizasInput[index].oriProducto.toLowerCase() === Transacts.products.RUMBO) || (polizasInput[index].nombreProducto != null && polizasInput[index].nombreProducto.toLowerCase() === Transacts.products.RUMBO)) {
          this.$root.$emit('isAvailableForHelpCenter', {})
          self.listSeguros.push({
            title: 'Rumbo',
            img: imgS3,
            txt1A: 'N° de póliza:',
            txt1B: polizasInput[index].numeroPoliza,
            txt2A: 'Monto de pago:',
            txt2B: (polizasInput[index].primaProgramadaMoneda.toLowerCase() === 'us dolar' ? '$ ' : 'S/ ') + polizasInput[index].primaProgramada.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'),
            policy: polizasInput[index],
            notiText: 'El monto indicado es tu prima programada.',
            noti: false
          })
        } else if ((polizasInput[index].oriProducto != null && polizasInput[index].oriProducto.toLowerCase() === 'vida con devolucion') || polizasInput[index].producto.toLowerCase() === 'vida cash') {
          this.$root.$emit('isAvailableForHelpCenter', {})
          self.listSeguros.push({
            title: 'Vida con Devolución',
            img: imgS3,
            txt1A: 'N° de póliza:',
            txt1B: polizasInput[index].numeroPoliza,
            txt2A: 'Suma asegurada:',
            txt2B: (polizasInput[index].primaProgramadaMoneda.toLowerCase() === 'us dolar' ? '$ ' : 'S/ ') + polizasInput[index].montoCoberturaPrincipal.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'),
            policy: polizasInput[index],
            notiText: 'El monto indicado es la suma asegurada por fallecimiento.',
            noti: false
          })
        } else if (polizasInput[index].ramo === 'Vida' && polizasInput[index].producto === 'Vida Free') {
          if (polizasInput[index].producto === 'Vida Free') {
            this.$root.$emit('isAvailableForHelpCenter', {})
          }
          self.listSeguros.push({
            title: polizasInput[index].producto,
            img: polizasInput[index].producto.toLowerCase().includes('educa') ? imgS2 : imgS3,
            txt1A: 'N° de póliza:',
            txt1B: polizasInput[index].numeroPoliza,
            // txt2A: ((polizasInput[index].producto.toLowerCase().includes('free') || polizasInput[index].producto.toLowerCase().includes('flex') || polizasInput[index].producto.toLowerCase().includes('educación')) ? 'Prima Programada:' : 'Suma Asegurada:'),
            // txt2B: (polizasInput[index].primaProgramadaMoneda.toLowerCase() === 'us dolar' ? '$ ' : 'S/ ') + ((polizasInput[index].producto.toLowerCase().includes('free') || polizasInput[index].producto.toLowerCase().includes('flex') || polizasInput[index].producto.toLowerCase().includes('educación')) ? polizasInput[index].primaProgramada : polizasInput[index].montoAsegurado),
            txt2A: 'Monto devolución:',
            txt2B: (polizasInput[index].primaProgramadaMoneda.toLowerCase() === 'us dolar' ? '$ ' : 'S/ ') + parseFloat(polizasInput[index].montoDevolucion).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'),
            policy: polizasInput[index],
            notiText: 'El monto indicado es la suma de tus aportes más rentabilidad.',
            noti: false
          })
        } else if (polizasInput[index].ramo === 'Vida') {
          if (polizasInput[index].producto === 'Plan Garantizado') {
            this.$root.$emit('isAvailableForHelpCenter', {})
          }
          self.listSeguros.push({
            title: polizasInput[index].producto,
            img: polizasInput[index].producto.toLowerCase().includes('educa') ? imgS2 : imgS3,
            txt1A: 'N° de póliza:',
            txt1B: polizasInput[index].numeroPoliza,
            // txt2A: ((polizasInput[index].producto.toLowerCase().includes('free') || polizasInput[index].producto.toLowerCase().includes('flex') || polizasInput[index].producto.toLowerCase().includes('educación')) ? 'Prima Programada:' : 'Suma Asegurada:'),
            // txt2B: (polizasInput[index].primaProgramadaMoneda.toLowerCase() === 'us dolar' ? '$ ' : 'S/ ') + ((polizasInput[index].producto.toLowerCase().includes('free') || polizasInput[index].producto.toLowerCase().includes('flex') || polizasInput[index].producto.toLowerCase().includes('educación')) ? polizasInput[index].primaProgramada : polizasInput[index].montoAsegurado),
            txt2A: 'Suma Asegurada:',
            txt2B: (polizasInput[index].primaProgramadaMoneda.toLowerCase() === 'us dolar' ? '$ ' : 'S/ ') + polizasInput[index].montoCoberturaPrincipal.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'),
            policy: polizasInput[index],
            notiText: 'El monto indicado es la suma asegurada por fallecimiento.',
            noti: false
          })
        } else if (polizasInput[index].ramo === 'RRVV') {
          self.listSeguros.push({
            title: polizasInput[index].modalidad,
            img: imgS3,
            txt1A: 'N° de póliza:',
            txt1B: polizasInput[index].numeroPoliza,
            // txt2A: (polizasInput[index].producto.toLowerCase() === 'renta vitalicia' ? 'Neto a pagar:' : 'Monto devolución:'),
            // txt2B: (polizasInput[index].primaProgramadaMoneda.toLowerCase() === 'us dolar' ? '$ ' : 'S/ ') + (polizasInput[index].producto.toLowerCase() === 'renta vitalicia' ? parseFloat(polizasInput[index].netoPago).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : parseFloat(polizasInput[index].montoDevolucion).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')),
            txt2A: 'Fin de vigencia:',
            txt2B: polizasInput[index].fechaFinVigencia,
            policy: polizasInput[index],
            notiText: (polizasInput[index].producto.toLowerCase() === 'renta vitalicia' ? 'El monto indicado es la renta mensual a pagar.' : 'El monto indicado es el monto de devolución que se te dará al finalizar tu póliza.'),
            noti: false
          })
        }
      }
      // CHECK USER FOR ACTIVE FORMALITIES
      let policy = polizasInput.map(f => { return f.ramo })
      let arr = policy.filter(f => f === 'Vida' || f === 'RRVV')
      if (arr.length > 0) {
        self.availableForFormalities = true
      }
      // CHECK IF USER APPLY FOR LOAN
      if (polizasRenta.length > 0) {
        self.flags.isRentas = true
        let promesasPrestamo = [];
        for (let index = 0; index < polizasRenta.length; index++) {
          let periodoGarantizado = polizasRenta[index].periodoGarantizado
          if (parseInt(periodoGarantizado) > 0) {
            promesasPrestamo.push(
              self.getInformacionPrestamo({poliza: polizasRenta[index].numeroPoliza, vista: 'Home'})
                .then((res) => {
                  if (res.data && (res.data.ingresoMensual > 1 || (res.data.devolucion.porcentaje && res.data.devolucionActual > res.data.devolucion.monto / 2))) {
                    quoter.setInfoDataPolicy(res.data)
                    let currency = (res.data.moneda.codigo === '001' || res.data.moneda.codigo === '013') ? 'S/' : '$'
                    const minLoanAmount = (currency === 'S/') ? quoter.loanLimits.min.PEN : quoter.loanLimits.min.USD
                    let minMaxLoan = quoter.calculateMaxMinLoan()
                    // Valida que monto del préstamo sea mayor o igual al mínimo definido en quoter y que sea mayor a 0
                    return (minMaxLoan.max >= minLoanAmount && minMaxLoan.max > 0) ? {
                      valida: true,
                      res,
                      minMaxLoan,
                      currency,
                      index
                    } : {valida: false};
                  }
                  return {valida: false};
                })
                .catch(() => ({valida: false}))
            );
          }
        }
        Promise.all(promesasPrestamo).then((resultados) => {
          const polizaValida = resultados.find(r => r.valida);
          if (polizaValida) {
            self.flags.loanAvailable = true;
            self.mainBanner.img = self.banners.prestamos.img;
            self.mainBanner.title = self.banners.prestamos.title;
            self.mainBanner.parraf = self.banners.prestamos.parraf;
            self.mainBanner.button = self.banners.prestamos.button;
            self.mainBanner.option = self.banners.prestamos.option;
            self.amountMaxLoanInfo = polizaValida.currency + ' ' + polizaValida.minMaxLoan.max.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
            // MOSTRAR EL MODAL CUANDO ES PRIMERIZO EN SOLICITAR EL PRESTAMO
            if ((polizaValida.res.data.prestamosAprobados && polizaValida.res.data.prestamosAprobados.length < 1)) {
              self.policyWhoHaveMaxLoan = polizasRenta[polizaValida.index].numeroPoliza;
              if (Functionalities.isAvailableSilent(Functionalities.rentas.PRESTAMOS, self.functionsRules, self)) {
                self.showLoansInformation = true;
              }
            }
          } else {
            self.flags.loanAvailable = false;
            self.mainBanner.img = self.banners.prepagos.img;
            self.mainBanner.title = self.banners.prepagos.title;
            self.mainBanner.parraf = self.banners.prepagos.parraf;
            self.mainBanner.button = self.banners.prepagos.button;
            self.mainBanner.option = self.banners.prepagos.option;
          }
          self.$root.$emit('isAvailableForMakeLoans', {});
        });
      } else {
        // HABILITAR BANNER PARA MAS SEGUROS SI NO APLICA CVC NI PRESTAMOS
        self.flags.moreProducts = true
        self.mainBanner.img = self.banners.masSeguros.img
        self.mainBanner.title = self.banners.masSeguros.title
        self.mainBanner.parraf = self.banners.masSeguros.parraf
        self.mainBanner.button = self.banners.masSeguros.button
      }
      // PARA LAS RENTAS RVI
      if (polizaRentaRVI.length > 0 && !self.flags.loanAvailable) {
        for (let index = 0; index < polizaRentaRVI.length; index++) {
          var renta = polizaRentaRVI[index]
          if (renta.codigoProducto === 'RVI' && this.tipoPensionRVI.includes(renta.tipoPension)) {
            self.flags.moreProducts = false
            self.flags.isRentas = true
            self.flags.rentaRVIAvailable = true
            self.mainBanner.img = self.banners.cronogramaRenta.img
            self.mainBanner.title = self.banners.cronogramaRenta.title
            self.mainBanner.parraf = self.banners.cronogramaRenta.parraf
            self.mainBanner.button = self.banners.cronogramaRenta.button
            self.mainBanner.option = null

            // POPUP-RENTAS
            if (new Date().getDate() >= 20 && new Date().getDate() <= 25) {
              // validar descarga en este mes
              let flagDescarga = JSON.parse(localStorage.getItem('downloadCalendar'))
              if (!flagDescarga) {
                // Cerrando Popup
                self.flagConogramaPago = false

                // Activando popup calendario rentas
                self.alertPopupData.flag = true
                self.alertPopupData.icon = require('@/assets/new-home/img-calendar2.svg')
                self.alertPopupData.title = self.banners.cronogramaRenta.title
                self.alertPopupData.message = self.banners.cronogramaRenta.parraf
                self.alertPopupData.messageButton = 'Descargalo aquí'
                self.alertPopupData.buttonClose = true
              }
            } else {
              localStorage.setItem('downloadCalendar', false)
            }

            break
          }
        }
      }
      // PARA HABILITAR EL BANNER - VIDA TIENE LA PRIORIDAD POR ESO ESTA AL FINAL
      const polizaVidaCVC = polizasVida.filter(f => f.oriProducto !== 'VIDA_CASH_PLUS')
      if (polizaVidaCVC.length > 0) {
        self.flags.cvcAvailable = true
        self.mainBanner.img = self.banners.pagoAuto.img
        self.mainBanner.title = self.banners.pagoAuto.title
        self.mainBanner.parraf = self.banners.pagoAuto.parraf
        self.mainBanner.button = self.banners.pagoAuto.button
        self.mainBanner.option = self.banners.pagoAuto.option
        // SI YA TIENE UNA VIA DE COBRO PUESTA. MOSTRAR EL OTRO BANNER SOLO PARA VIDA Y VEHICULAR
        if (polizasVida[0].viaDeCobro !== '') {
          self.mainBanner.img = self.banners.pagoRealizado.img
          self.mainBanner.title = self.banners.pagoRealizado.title
          self.mainBanner.parraf = self.banners.pagoRealizado.parraf
          self.mainBanner.button = self.banners.pagoRealizado.button
          self.mainBanner.option = self.banners.pagoRealizado.option
          // Agregar una clase especial, solo para este banner
          try {
            document.querySelector('.inicio-panel-banner figure img').classList.add('fixed-banner')
            document.querySelector('.inicio-panel-banner article div h3').classList.add('fixed-banner')
            document.querySelector('.inicio-panel-banner button').classList.add('fixed-banner')
          } catch (e) {}
        }
      }
      this.cargarPrestamosVidaDisponibilidad(polizasInput)
      // REESCALA DEL MENU
      // let height = document.querySelector('.inicio-main-dash').offsetHeight || clientHeight
      // var elmenu = document.getElementsByClassName('menu')[0]
      // elmenu.style = 'height: ' + height + 'px'
      // GET REQUIREMENTS FOR HOME
      let axiosRequests = []
      for (let i = 0; i < polizasInput.length; i++) {
        axiosRequests.push(self.getAllRequirementsPerPolicy({ numeroPoliza: polizasInput[i].numeroPoliza }))
      }
      axios.all(axiosRequests).then(function (results) {
        const reqArray = []
        results.forEach(function (res) {
          reqArray.push(...res.data.data)
        })

        self.requirements = reqArray.sort((a, b) => {
          return (a.id < b.id) ? 1 : (a.id > b.id) ? -1 : 0
        }).map(req => {
          const aux = polizasInput.find((item) => item.numeroPoliza === req.policy)
          const newDesign = !!aux && (
            ['VIDACASH', 'VIDAFREE', 'EDUCACIONGARANTIZADAPLUS', 'EDUCGARANTIZADAPLUSNEW'].includes(aux.nombreProducto || '') ||
            ['Plan Garantizado', 'Educación Garantizada'].includes(aux.oriProducto || '')
          )
          let percent = '10'
          let status = 'Creado'
          if (req.state != null && req.state.includes('PENDIENTE')) {
            const ms = new Date().getTime() - new Date(req.created_at).getTime
            if (ms > 60000) {
              percent = '20'
              status = 'En curso'
            }
          } else if (req.state != null && req.state.includes('ERROR') && req.state.includes('RPA')) {
            percent = '50'
            status = 'En curso'
          } else if (req.state != null && req.state.includes('PROCESADO') && !req.state.includes('RPA')) {
            percent = '100'
            status = 'Finalizado'
          } else if (req.state != null && (req.state.includes('ERROR') || req.state.includes('ATENDIDO') || req.state.includes('PROCESADO RPA') || req.state.toUpperCase().includes('CONFORME') || req.state.includes('RECHAZADO'))) {
            percent = req.state.includes('ERROR') ? '80' : '100'
            status = req.state.includes('ERROR') ? 'En curso' : 'Finalizado'
          }
          return {
            id: req.id,
            title: req.transact,
            code: req.num_code,
            percent: percent,
            status: status,
            selected: false,
            requirement: req,
            newDesign
          }
        })
      })
      this.getPaymentsPendings(polizasVida)
    },
    trackGoverPhone () {
      // EVENT TRACK - Universal Analytics
      this.$gtm.trackEvent({
        event: 'virtualEvent',
        category: 'Zona Segura',
        action: 'Home - Contáctanos',
        label: 'Seleccionar link - Número'
      })
      // EVENT TRACK - GA4
      this.$gtm.trackEvent({
        event: 'select_button',
        'Nombre Sección': 'Zona Segura',
        TipoElemento: 'Link',
        TipoAccion: 'Home - Contáctanos',
        CTA: 'Seleccionar link - Número'
      })
    },
    getBasicInfo (callback) {
      let self = this
      if (self.basicInfo === null) {
        self.getUserInfo(self.userInfo).then(res => {
          if (res.data.codigoRespuesta === '01') {
            callback(res.data)
          }
        })
      } else {
        callback(self.basicInfo)
      }
    },
    validateViagenciaPolizasSOAT (polizasInput) {
      let polizasSOAT = polizasInput.filter(p => p.ramo === 'Masivo' && p.producto === 'SOAT')
      this.placasSOATExpiring = []
      polizasSOAT.forEach(p => {
        if (this.getStatusVigenciaMasivo(p.fechaFinVigenciaMasivo)) {
          this.placasSOATExpiring.push(p.placa)
        }
      })
      if (this.placasSOATExpiring.length > 0) {
        this.showExpiringPolizasSOAT = true
      } else {
        this.showExpiringPolizasSOAT = false
      }
    },
    getStatusVigenciaMasivo (fechaVencimiento) {
      let dia, mes, anio
      if (fechaVencimiento.split('-')[2] !== undefined) {
        let split = fechaVencimiento.split('-')
        dia = parseInt(split[2])
        mes = parseInt(split[1]) - 1
        anio = parseInt(split[0])
      } else {
        let split = fechaVencimiento.split('/')
        dia = parseInt(split[0])
        mes = parseInt(split[1]) - 1
        anio = parseInt(split[2])
      }
      let currentDate = new Date()
      let finVigenciaDate = new Date(anio, mes, dia)
      let diff = (finVigenciaDate - currentDate)
      if (diff < 0) {
        return true
      } else {
        const expirationDays = diff / (1000 * 3600 * 24)
        if (expirationDays <= 45) {
          return true
        }
      }
      return true
    },
    getMesActual () {
      const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
      const now = new Date()
      return meses[now.getMonth()]
    },
    closeModal (type) {
      switch (type) {
      case 'vida':
        this.flags.showGuaranteed = false
        break

      case 'rentas':
        this.flags.showAnnuity = false
        break

      default:
        this.flags.showMasivo = false
        break
      }
    },
    logout () {
      const self = this
      self.$swal({
        title: '¡Sin productos disponibles para <br>tu Zona Segura!',
        text: 'Estamos trabajando para que puedas realizar más operaciones. Pronto te enterarás de más novedades.',
        confirmButtonText: 'Entendido'
      }).then(() => {
        self.$store.commit('user/setSearch', '')
        // CLEAR ALL INTERVALS
        clearInterval(self.interval)
        self.loader = true
        // FOR CLIENTS RPP/IFP
        if (localStorage.removeItem('jwt') !== null) {
          self.$store.state.user.haveLoanRequested = null
          self.$store.state.user.session = null
          self.$store.state.user.jwt = null
          self.$store.state.user.coUs = null
          self.$store.state.user.info = null
          self.$store.state.user.user = null
          self.$store.state.user.polizas = null
          self.$store.state.user.historyPayments = null
          self.$store.state.user.exp = null
          self.$store.state.user.names = null
          this.$store.state.user.functions = null
          localStorage.removeItem('products')
          self.$router.push('/')
        }
      })
    },
    closeAlerPopupMethod (item) {
      this.alertPopupData.flag = false
      this.popupSorteo.flag = false
      this.flagConogramaPago = true
      this.popupPrestamosVida.flag = false
      this.hasSeenPopup = true

      if (item) {
        // FLAG LOCAL LUEGO DE LA DESCARGA - NO REAPARECER LUEGO DE DESCARGAR
        localStorage.setItem('downloadCalendar', true)
        this.checkAndDownloadPDFRentas()
      }
    },
    goToRequirement (req) {
      if (!req.newDesign) {
        return
      }
      const poliza = this.listSeguros.find((item) => item.policy.numeroPoliza === req.requirement.policy)
      this.display(poliza.policy, { action: 'mis solicitudes', data: req })
    },
    switchTrackingPop (value) {
      this.flagTrackRequirements = value
    },
    aplicarBannerPrestamosVida () {
      this.mainBanner.img = this.banners.prestamosVida.img
      this.mainBanner.title = this.banners.prestamosVida.title
      this.mainBanner.parraf = this.banners.prestamosVida.parraf
      this.mainBanner.button = this.banners.prestamosVida.button
      this.mainBanner.option = this.banners.prestamosVida.option
      try {
        document.querySelector('.inicio-panel-banner')
          .classList.add('prestamosvida-mobile')
        document.querySelector('.inicio-panel-banner article')
          .classList.add('prestamosvida-banner')
        document.querySelector('.inicio-panel-banner button')
          .classList.add('prestamosvida-button')
      } catch (error) {}
    },
    /**
     * Aplica flag y banner de Préstamos Vida a partir del payload de disponibilidad.
     * @param {Object} data - Respuesta de disponibilidad (store o API)
     */
    aplicarDisponibilidadDesdePayload (data) {
      if (!data) {
        this.flags.prestamosVidaAvailable = false
        return
      }
      const habilitado = data.codigoRespuesta === '01' && data.prestamoVidaHabilitado
      this.flags.prestamosVidaAvailable = !!habilitado
      if (habilitado) {
        this.aplicarBannerPrestamosVida()
      }
    },
    /**
     * Hidrata UI desde cache (si existe) y siempre refresca disponibilidad en background.
     * Evita el flash del banner al reentrar al Home sin dejar flags desactualizados.
     * @returns {Promise}
     */
    cargarPrestamosVidaDisponibilidad () {
      const cached = this.prestamosVidaDisponibilidad
      if (cached) {
        this.aplicarDisponibilidadDesdePayload(cached)
      }

      const promise = this._prestamosVidaPromise || this.getPrestamosVidaDisponibilidad()
      this._prestamosVidaPromise = promise

      return promise
        .then(res => {
          if (!res || !res.data) {
            if (!cached) {
              this.flags.prestamosVidaAvailable = false
            }
            return
          }
          this.aplicarDisponibilidadDesdePayload(res.data)
        })
        .catch(() => {
          if (!cached) {
            this.flags.prestamosVidaAvailable = false
          }
        })
    },

  },
  computed: {
    ...mapGetters('user', ['polizasInfo', 'userInfo', 'loanRequested', 'basicInfo', 'functionsRules', 'extraInfo', 'viveMasEnabled', 'tieneSolicitudPrestamoVidaEnEvaluacion', 'prestamosVidaDisponibilidad']),
    columns () {
      if (this.$vuetify.breakpoint.xl) {
        return 3
      }

      if (this.$vuetify.breakpoint.lg) {
        return 3
      }

      if (this.$vuetify.breakpoint.md) {
        return 3
      }

      return 1
    },
    /**
     * Determina si debe mostrar el componente de beneficios Vive más
     * El flag del backend SOLO afecta a usuarios con TODAS las pólizas RPP
     * @returns {boolean} true si debe mostrar, false si TODAS las pólizas son RPP y el flag está deshabilitado
     */
    shouldShowViveMas() {
      // 1. Sin pólizas → SIEMPRE mostrar (comportamiento original)
      if (!this.polizasInfo || this.polizasInfo.length === 0) {
        return true
      }

      // 2. Verificar si TODAS son RPP
      const todasSonRPP = this.polizasInfo.every(poliza => poliza.codigoProducto === 'RPP')

      // 3. Si tiene AL MENOS 1 póliza NO-RPP → SIEMPRE mostrar (ignora flag)
      if (!todasSonRPP) {
        return true
      }

      // 4. Si TODAS son RPP → el flag controla la visibilidad
      return this.viveMasEnabled
    },
    profileName() {
      // Priorizar basicInfo (datos completos del API)
      if (this.basicInfo && this.basicInfo.nombres && this.basicInfo.nombres.trim() !== '') {
        console.log('✅ Usando basicInfo:', this.basicInfo)
        const chars = this.basicInfo.nombres.split(' ')
        return chars[0].charAt(0).toUpperCase() + chars[0].slice(1).toLowerCase()
      }
      
      // Fallback a userInfo (datos del login)
      if (this.userInfo && this.userInfo.nombreUsuario && this.userInfo.nombreUsuario.trim() !== '') {
        console.log('⚠️ Usando userInfo:', this.userInfo)
        const chars = this.userInfo.nombreUsuario.split(' ')
        return chars[0].charAt(0).toUpperCase() + chars[0].slice(1).toLowerCase()
      }
      return 'Cliente'
    }
  },
  created () {
    let products = localStorage.getItem('products')
    let self = this
    if (products && products !== null) {
      let productsArray = JSON.parse(products).map(p => p.toLowerCase())
      self.flags.isOnlySoat = productsArray.length === 1 && products.includes('soat')
      self.flags.isRentas = productsArray.length > 0 && products.includes('Renta')
    }
  },
  mounted () {
    let self = this
    const available = Functionalities.isAvailableSilent(Functionalities.Mantenimiento, self.functionsRules, self)
    if (!available) {
      self.$swal({
        title: self.functionsRules[Functionalities.Mantenimiento].titulo,
        html: self.functionsRules[Functionalities.Mantenimiento].mensaje,
        imageUrl: self.functionsRules[Functionalities.Mantenimiento].imagen || require('./../assets/characters/informa.svg'),
        confirmButtonText: 'Entendido'
      }).then(() => {
        self.$store.commit('user/setSearch', '')
        self.loader = true
        // FOR CLIENTS RPP/IFP
        if (localStorage.removeItem('jwt') !== null) {
          self.$store.state.user.haveLoanRequested = null
          self.$store.state.user.session = null
          self.$store.state.user.jwt = null
          self.$store.state.user.coUs = null
          self.$store.state.user.info = null
          self.$store.state.user.user = null
          self.$store.state.user.polizas = null
          self.$store.state.user.historyPayments = null
          self.$store.state.user.exp = null
          self.$store.state.user.names = null
          this.$store.state.user.functions = null
          localStorage.removeItem('products')
          self.$router.push('/')
        }
      })
      return
    } else {
      Functionalities.isAvailable(Functionalities.Info, self.functionsRules, self)
    }

    /*
    // DESACTIVACION PRESTAMOS PREPAGOS 2023-02-23
    self.$root.$on('notIsAvailableForMakeLoans', () => {
      const start = moment().format('YYYY-MM-DD hh:mm:ss')
      const end = moment('2024-02-29 23:00:00').format('YYYY-MM-DD hh:mm:ss')
      if (moment(start).isSameOrBefore(moment(end))) {
        self.popupSorteo.buttonClose = true
        self.popupSorteo.icon = require('@/assets/nps/person-7-8.svg')
        self.popupSorteo.title = ''
        self.popupSorteo.flag = true
        self.popupSorteo.message = 'Hola, queremos informarte que desde las 11pm del <strong>23/02</strong>, algunas de nuestras funcionalidades no estarán disponibles debido a un mantenimiento en la plataforma. <br><br>Te pedimos disculpas por los posibles inconvenientes que esto pueda generar.'
        self.popupSorteo.messageButton = 'Entendido'
        self.popupSorteo.link = false
      }
    })
    */

    this.$store.commit('user/setHaveLoanRequested', null)
    this.$store.commit('loans/setOnboarding', 1)
    let polizasInput = null
    this.popupPrestamosVida.data = this.extraInfo;

    /** GET POLIZAS BTW */
    if (this.polizasInfo === null) {
      self.loaderHome = true
      self._prestamosVidaPromise = self.getPrestamosVidaDisponibilidad().catch(() => null)

      Promise.all([
        self.getPolizas(self.userInfo),
        self._prestamosVidaPromise
      ]).then(([res]) => {
        self.loaderHome = false
        polizasInput = res.data.polizas.filter(x => !(x.canal && x.canal.toUpperCase() === 'FALABELLA') && !x.producto.toLowerCase().includes('viajes'))
        if (polizasInput.length < 1) {
          self.logout()
        } else {
          self.afterLoadPolizas(res.data.polizas)
          // let containPolizaVida = res.data.polizas.filter(f => { return f.ramo === 'Vida' })
          let containPolizasSOAT = res.data.polizas.filter(f => { return f.producto === 'SOAT' })
          if (containPolizasSOAT.length === (res.data.polizas).length) {
            self.$root.$emit('isNotAvailableForRequirements', {})
          }
          self.$root.$emit('donePolizas', {})
          self.$root.$emit('npsInactivity', {seccion: 'Home'})
          // self.validateViagenciaPolizasSOAT(polizasInput)
        }

        // Mostrar popup sorteo en rango de fechas
        const today = moment().format('YYYY-MM-DD')
        const deadline = moment('2023-11-26').format('YYYY-MM-DD')
        if (moment(today).isSameOrBefore(moment(deadline))) {
          polizasInput.map(poliza => {
            self.popupSorteo.buttonClose = true
            self.popupSorteo.icon = require('@/assets/icons/icon-coupon-enabled.gif')
            self.popupSorteo.title = '¡Tenemos un sorteo para ti!'
            if ((poliza.ramo || '').toLowerCase().includes('vida') ||
                (poliza.ramo || '').toLowerCase().includes('rrvv') ||
                (poliza.nombreProducto || '').toLowerCase().includes('vehicular')) {
              self.popupSorteo.flag = true
              self.popupSorteo.message = 'Descarga tu póliza electrónica y participa por uno de los <b class="omnesSemibold">10 vales</b> de <b class="omnesSemibold">S/200</b> en Agora.<br>Sorteo válido del 20 al 26 de noviembre del 2023.'
              self.popupSorteo.messageButton = 'Entendido'
              self.popupSorteo.link = false
            } else if ((poliza.producto || '').toLowerCase().includes('soat')) {
              self.popupSorteo.flag = true
              self.popupSorteo.message = 'Descarga tu certificado SOAT y participa por uno de los <b class="omnesSemibold">10 vales</b> de <b class="omnesSemibold">S/200</b> en Agora.<br>Sorteo válido del 20 al 26 de noviembre del 2023.'
              self.popupSorteo.messageButton = 'Entendido'
              self.popupSorteo.link = false
            }
          })
        }

      }).catch(() => {
        self.loaderHome = false
      })
    } else {
      this.getPolizas({isCalled:true})
        .then((res) => {
          let polizasInput = res.data.polizas.filter(x =>
            !(x.canal && x.canal.toUpperCase() === 'FALABELLA') &&
            !x.producto.toLowerCase().includes('viajes')
          );

          if (polizasInput.length < 1) {
            self.logout();
          } else {
            self.afterLoadPolizas(res.data.polizas);
            let containPolizasSOAT = res.data.polizas.filter(f => f.producto === 'SOAT');

            if (containPolizasSOAT.length === self.polizasInfo.length) {
              self.$root.$emit('isNotAvailableForRequirements', {});
            }
            self.$root.$emit('npsInactivity', { seccion: 'Home' });
          }
        });

      polizasInput = self.polizasInfo.filter(x => !(x.canal && x.canal.toUpperCase() === 'FALABELLA') && !x.producto.toLowerCase().includes('viajes'))
      if (polizasInput.length < 1) {
        self.logout()
      } else {
        // ONLY FOR PRESTAMOS
        self.afterLoadPolizas(self.polizasInfo)
        // FOR MAKE APPEAR OPTION PAGOS IN PROTECTED LAYOUT
        // let containPolizaVida = self.polizasInfo.filter(f => { return f.ramo === 'Vida' })
        let containPolizasSOAT = self.polizasInfo.filter(f => { return f.producto === 'SOAT' })
        if (containPolizasSOAT.length === (self.polizasInfo).length) {
          this.$root.$emit('isNotAvailableForRequirements', {})
        }
        this.$root.$emit('npsInactivity', {seccion: 'Home'})
      }
    }

    const callback = () => {
      const hashId = getHashIS((self.basicInfo.tipoDocumento === 'DNI' ? '1' : '2').toString().padStart(2, '0'), self.basicInfo.numeroDocumento)
      try {
        window.hj('identify', hashId, {
          'numeroDocumento': self.basicInfo.numeroDocumento,
          'tipoDocumento': self.basicInfo.tipoDocumento,
          'email': self.basicInfo.correo,
          'celular': self.basicInfo.celular
        })
      } catch (e) {
        // console.log('Error hotjar', e)
      }
    }
    if (this.userInfo) {
      // LAS NUEVAS MARCACIONES GTM NOS MUEVE TODO...
      if (this.basicInfo === null) {
        self.getUserInfo(this.userInfo).then(res => {
          if (res.data.codigoRespuesta === '01') {
            // EVENT TRACK - GA
            /* this.$gtm.trackEvent({
              userID: this.basicInfo.numeroDocumento,
              loginStatus: 'Sesión Iniciada',
              empresa: 'Interseguro'
            }) */
            callback()
          }
        })
      } else {
        callback()
      }
    }
    // EVENT TRACK - Universal Analytics
    this.$gtm.trackEvent({
      event: 'virtualEvent',
      category: 'Zona Segura',
      action: 'Inicio de sesión',
      label: 'Ingreso satisfactorio'
    })
    // EVENT TRACK - GA4
    this.$gtm.trackEvent({
      event: 'select_button',
      'Nombre Sección': 'Zona Segura',
      TipoElemento: 'Botón',
      TipoAccion: 'Inicio de sesión',
      CTA: 'Ingreso satisfactorio'
    })
  },
  components: {
    DialogMoreInsurances,
    DialogContactUs,
    PulseLoader,
    'form-annuity': FormAnnuity,
    'form-masivo': FormMasivo,
    'form-guaranteed-education': FormGuaranteedEducation,
    'popup-alerta': PopupAlertMessage,
    PopupSorteo,
    CardTrackingSolicitudes,
    PopupTrackingSolicitudes,
    PopupPrestamosVida,
    PopupSolicitudEnCurso
  }
}
</script>

<style>
.inicio-extra-gray {
  align-items: center;
  background: #F2F2F2;
  border-radius: 14.28px;
  display: flex;
  height: 297px;
  justify-content: center;
  margin: auto;
}

.inicio-extra-gray div {
  text-align: center;
}

.inicio-extra-gray p {
  color: #C2C2C2;
  font-size: 16px;
  margin-top: 15px;
}

.inicio-notificacion {
  align-items: center;
  background: white;
  border-radius: 50%;
  display: flex;
  height: 33px;
  justify-content: center;
  width: 33px;
}

.inicio main .container {
  padding: 0 !important;
}

.inicio-panel {
  background: #FFFFFF;
  padding-bottom: 22px;
  padding-top: 15px;
}

.inicio-panel h1 {
  color: var(--text-color);
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 15px;
}

.inicio-panel-block-1 h2,
.inicio-panel-block-2 h2 {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 2px;
}

.inicio-panel-block-2 .contactanos{
  margin-top: 35px;
}

.inicio-panel-block-1-btn {
  align-items: center;
  background: white;
  border: 1.59px solid #F2F2F2;
  box-shadow: 0px 2.89px 2.89px rgba(112, 112, 112, 0.25);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  height: 37px;
  width: 37px;
}

.inicio-panel-banner {
  align-items: center;
  background-color: var(--first-brand-color);
  border-radius: 16px;
  display: flex;
  padding: 15px 5% !important;
}

.inicio-panel-banner h3,
.inicio-panel-banner p {
  color: white;
}

.inicio-panel-banner h3 {
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 10px;
}

.inicio-panel-banner p {
  font-size: 14px;
  margin-bottom: 0 !important;
}

.inicio-panel-banner button {
  align-items: center;
  background: var(--fuchsia-color);
  border-radius: 4px;
  display: flex;
  color: white;
  font-family: "Omnes Regular", sans-serif;
  font-weight: 500px;
  font-size: 16px;
  justify-content: center;
  height: 29px;
  width: 190px;
}

#formalities button.see-more {
  align-items: center;
  background: var(--fuchsia-color);
  border-radius: 4px;
  display: flex;
  color: white;
  font-family: "Omnes Regular", sans-serif;
  font-weight: 400px;
  font-size: 18px;
  justify-content: center;
  height: 40px;
  width: 150px;
}

.inicio-panel-block-1-list .v-carousel {
  box-shadow: none !important;
  height: 160px !important;
}

.inicio-panel-block-1-list article {
  background: #FFFFFF;
  border: 1.67837px solid #F2F2F2;
  box-sizing: border-box;
  box-shadow: 0px 3.05063px 6px rgba(159, 159, 159, 0.16);
  border-radius: 16.8893px;
  margin-top: 10px;
  padding-bottom: 20px;
  padding-top: 15px;
}

.inicio-panel-block-1-list article figure {
  align-items: center;
  display: flex;
  height: 50px;
  justify-content: center;
  margin-bottom: 5px;
}

.inicio-panel-block-1-list article h3 {
  color: var(--text-color);
  font-weight: 500;
  margin: -2px -5px 5px -5px;
}

.inicio-panel-block-1-list article p {
  margin-bottom: 0 !important;
}

.inicio-panel-block-1-list article .g-flex {
  margin-top: 7px;
}

.inicio-panel-block-1-list article .g-flex p:nth-of-type(1) {
  color: var(--second-brand-color);
}

.inicio-panel-block-1-list article .g-flex p:nth-of-type(2) {
  margin-left: auto;
  margin-right: 0;
  text-align: right;
}

.inicio-panel-block-1-descrip {
  margin-left: auto;
  margin-right: auto;
  width: 80%;
}

.inicio-panel-block-1-descrip .g-flex {
  position: relative;
}

.inicio-panel-block-1-descrip svg {
  position: absolute;
  right: -17px;
  top: 3px;
}

.inicio-panel-pagos-list {
  display: flex;
  flex-wrap: wrap;
}

.inicio-panel-pagos-list article {
  display: flex;
  padding: 15px 8px !important;
}

.inicio-panel-pagos-list article>div {
  width: 100%;
}

.inicio-panel-pagos-list article>div .g-flex {
  width: inherit;
  height: 100%;
  align-items: center;
}

.inicio-panel-pagos-list article figure {
  align-items: center;
  justify-content: center;
  display: flex;
  height: 100%;
}

.inicio-panel-pagos-list article figure img {
  width: 100%;
}

.inicio-panel-pagos-list .d-flex p {
  font-size: 14px;
}

.inicio-panel-pagos-list .d-flex p:nth-of-type(1) {
  color: var(--second-brand-color);
}

.inicio-panel-pagos-list .d-flex p:nth-of-type(2) {
  color: black;
  margin-left: 3px;
}

.inicio-panel-pagos article p {
  margin-bottom: 0;
}

.inicio-panel-pagos article h3 {
  color: var(--text-color);
  font-size: 16px;
  font-weight: 500;
  line-height: 18px;
}

.inicio-panel-pagos article h3 span {
  display: block;
}

.inicio-panel-pagos article,
.inicio-panel-contacto article {
  background: #FFFFFF;
  border: 1.67837px solid #F2F2F2;
  box-sizing: border-box;
  box-shadow: 0px 3.05063px 6px rgba(159, 159, 159, 0.16);
  border-radius: 16.8893px;
  margin-top: 0;
  height: 95px;
  transition: .2s ease-in-out;
}

.inicio-panel-contacto article {
  width: 260px;
}

.inicio-panel-contacto article {
  padding-top: 5px;
}

.inicio-panel-contacto article .g-flex {
  margin-top: 15px;
  margin-left: 23px;
}

.inicio-panel-contacto article a {
  color: var(--first-brand-color);
  margin-left: 13px;
}

.inicio-extra {
  background: white;
}

.inicio-extra h2 {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 12px;
}

.inicio-extra p {
  margin-bottom: 0;
}

.inicio-extra article {
  background: #FFFFFF;
  border: 1.41874px solid #F2F2F2;
  box-sizing: border-box;
  box-shadow: 0px 3.05063px 6px rgba(159, 159, 159, 0.16);
  border-radius: 14.2766px;
  width: 100%;
  transition: .2s ease-in-out;
}

.inicio-extra section {
  margin-top: 35px !important;
}

.inicio-extra section:nth-of-type(1) article {
  height: 99px;
}

.inicio-extra section:nth-of-type(1) article figure {
  width: 125px;
}

.inicio-extra section:nth-of-type(1) p {
  color: var(--text-color);
  font-size: 14px;
  font-weight: 500;
}

.inicio-extra section:nth-of-type(2) {
  display: block !important;
  margin-bottom: 25px;
}

.inicio-extra section:nth-of-type(2) article {
  padding: 7px 15px 5px 15px;
}

.inicio-extra section:nth-of-type(2) article:not(:nth-of-type(1)) {
  margin-top: 25px;
}

.inicio-extra-item-title {
  margin-bottom: 10px;
  margin-top: 10px;
}

.inicio-extra-item-title p {
  color: var(--text-color);
  font-size: 14px;
}

.inicio-extra-item-title p:nth-of-type(2) {
  margin-left: 5px;
}

.inicio-extra-item-porcent p {
  color: var(--first-brand-color);
  font-size: 12px;
}

.inicio-extra-item-porcent p:nth-of-type(1) {
  text-align: right;
}

.inicio-extra-item-porcent div,
.inicio-extra-item-porcent aside {
  border-radius: 8px;
  height: 6px;
}

.inicio-extra-item-porcent div {
  background: #D9D9D9;
  margin-bottom: 10px;
  margin-top: 5px;
  position: relative;
  max-width: 260px;
  z-index: 2;
}

.inicio-extra-item-porcent aside {
  background: var(--first-brand-color);
  left: 0;
  position: absolute;
  top: 0;
  z-index: 5;
}

.inicio-extra-item-fecha {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.inicio-extra-item-fecha p {
  color: #919191;
  font-size: 14px;
  margin-left: 7px;
}

.inicio-extra button,
.text-info-loans .btn-text-info-loans button,
#choose-product-loans .choosenBtn button:not(.v-btn--disabled) {
  align-items: center;
  background: var(--fuchsia-color) !important;
  border-radius: 4px;
  display: flex;
  color: white;
  font-family: "Omnes Semibold", sans-serif;
  font-size: 18px;
  justify-content: center;
  margin: 25px auto 0 auto;
  text-transform: initial;
}

#choose-product-loans .choosenBtn button:not(.v-btn--disabled) {
  height: 51px;
  width: 250px;
}

.inicio-extra button {
  height: 39px;
  width: 110px;
}

.text-info-loans .btn-text-info-loans button {
  height: 55px;
  width: 145px;
}

.cursor-progress {
  cursor: progress;
}

.cursor-wait {
  cursor: wait;
}

.inicio-panel-banner figure {
  max-width: 140px;
}

.inicio-panel-banner figure img {
  max-width: 100%;
}

.inicio-panel-banner figure img.fixed-banner {
  width: 80%;
}

.btn-text-info-soat-expiring {
  text-align: center;
}

.btn-text-info-soat-expiring button {
  background-color: var(--fuchsia-color) !important;
  color: white !important;
  font-family: "Omnes Regular", sans-serif;
  font-size: 16px;
  justify-content: center;
  box-shadow: none !important;
  height: 44px;
  width: 160px;
  border-radius: 5px;
}

.card_expired-soat {
  border-radius: 7px;
}

/** TOOLTIPS FOR INFO POLIZA IN HOME */
.v-card.tooltip-dash-info-poliza {
  background-color: var(--text-color);
  border-radius: 5px;
  padding: 15px;
}

.v-card.tooltip-dash-info-poliza span {
  color: #FFF;
}

/* Small to large handset ----------- */
@media only screen and (max-width: 600px) {
  .inicio-panel {
    border: 0;
    padding-bottom: 0 !important;
  }

  .inicio-main-dash .inicio-panel .inicio-panel-banner figure {
    padding-left: 7px;
  }

  .inicio-main-dash .inicio-panel .inicio-panel-banner article {
    margin-left: 8px;
  }

  .inicio-panel-banner h3 {
    font-size: 15.5px;
  }

  .inicio-panel-banner p {
    font-size: 12.5px;
  }

  .inicio-panel-banner h3,
  .inicio-panel-banner p{
    color: white;
  }
  .inicio-panel-banner h3{
    font-weight: 500;
    font-size: 16px;
    margin-bottom: 10px;
  }
  .inicio-panel-banner p{
    font-size: 14px;
    margin-bottom: 0!important;
  }
  .inicio-panel-banner button{
    align-items: center;
    background: var(--fuchsia-color);
    border-radius: 4px;
    display: flex;
    color: white;
    font-family: "Omnes Regular", sans-serif;
    font-weight: 400px;
    font-size: 16px;
    justify-content: center;
    height: 40px;
    width: 190px;
  }

  #formalities button.see-more {
    align-items: center;
    background: var(--fuchsia-color);
    border-radius: 4px;
    display: flex;
    color: white;
    font-family: "Omnes Regular", sans-serif;
    font-weight: 400px;
    font-size: 18px;
    justify-content: center;
    height: 48px;
    width: 150px;
  }
  .inicio-panel-block-1-list article{
    background: #FFFFFF;
    border: 1.67837px solid #F2F2F2;
    box-sizing: border-box;
    box-shadow: 0px 3.05063px 6px rgba(159, 159, 159, 0.16);
    border-radius: 16.8893px;
    margin-top: 10px;
    padding-bottom: 20px;
    padding-top: 15px;
    width: 261px;
  }
  .inicio-panel-block-1-list article figure{
    align-items: center;
    display: flex;
    height: 50px;
    justify-content: center;
    margin-bottom: 5px;
  }
  .inicio-panel-block-1-list article h3{
    color: var(--text-color);
    font-weight: 500;
    margin: -2px -5px 5px -5px;
  }
  .inicio-panel-block-1-list article p{
    margin-bottom: 0!important;
  }

  .inicio-panel-block-1-descrip {
    width: 62% !important;
  }

  .inicio-panel-block-1-list .v-carousel .v-carousel__next {
    display: none;
  }

  .inicio-panel-banner article button.fixed-banner {
    font-size: 14px;
  }
  .inicio-panel-pagos-list .d-flex p:nth-of-type(1){
    color: var(--second-brand-color);
  }
  .inicio-panel-pagos-list .d-flex p:nth-of-type(2){
    color:black;
    margin-left: 3px;
  }
  .inicio-panel-pagos article p{
    margin-bottom: 0;
  }
  .inicio-panel-pagos article h3{
    color: var(--text-color);
    font-size: 16px;
    font-weight: 500;
    line-height: 18px;
  }
  .inicio-panel-pagos article h3 span{
    display: block;
  }

  .inicio-panel-pagos article,
  .inicio-panel-contacto article{
    background: #FFFFFF;
    border: 1.67837px solid #F2F2F2;
    box-sizing: border-box;
    box-shadow: 0px 3.05063px 6px rgba(159, 159, 159, 0.16);
    border-radius: 16.8893px;
    margin-top: 10px;
    height: 95px;
  }
}

@media screen and (max-width: 1023px) {
  .inicio-panel-contacto {
    margin-top: 20px;
  }

  .inicio-panel-content {
    margin: auto;
    width: 90%;
  }

  .inicio-panel-banner figure {
    margin: auto;
  }

  .inicio-panel-banner img {
    max-width: 100%;
  }

  .inicio-panel-banner article {
    margin-left: 5px;

  }

  .inicio-panel-banner article p {
    padding-right: 15px;
  }

  .inicio-panel-banner button {
    margin-top: 15px;
  }

  .inicio-extra {
    margin: auto;
    padding: 0 0 1px;
    width: 90%;
  }

  .inicio-panel-block-1-list article {
    align-items: center;
    display: flex;
    padding-left: 0px;
    width: 100%;
  }

  .inicio-panel-block-1-list article h3 {
    margin: -2px -5px 5px -5px;

  }

  .inicio-panel-block-1-list figure {
    margin-bottom: 0;
    padding-top: 10px;
    height: auto;
    width: 27%;
  }

  .inicio-panel-block-1-list article:not(:nth-of-type(1)) {
    margin-top: 20px;
  }

  .inicio-panel-block-1-descrip {
    padding-right: 17px;
    width: 70%;
  }

  .inicio-panel-pagos-list article,
  .inicio-panel-contacto article {
    width: 100%;
  }

  .inicio-panel-pagos-list .g-flex figure {
    text-align: center;
    margin-left: 25px;
    width: 45px !important;
    max-width: 50px;
  }

  .inicio-panel-block-1-btn {
    margin: 15px auto 0 auto;
  }

  .inicio-extra .benefit {
    padding: 15px;
  }

  .inicio-extra section:nth-of-type(1) article div {
    margin-left: 16px;
  }

  .inicio-extra section:nth-of-type(1) article figure {
    width: auto;
  }

  .inicio-extra section:nth-of-type(1) article p {
    padding-right: 10px;
  }
}

@media screen and (min-width: 1024px) {
  .inicio-main-dash {
    height: auto;
  }

  .inicio-extra article {
    max-width: 308px;
  }

  .inicio-extra article:hover {
    border: 1px solid var(--first-brand-color);
  }

  .inicio-extra section {
    margin-top: 25px !important;
  }

  .inicio-extra section:nth-of-type(2) {
    height: auto !important;
    min-height: auto !important;
    margin-bottom: 0;
  }

  .inicio-extra section:nth-of-type(1) article {
    padding: 5px;
  }

  .inicio-panel h1 {
    font-size: 18px;
    margin-top: 3px;
    margin-bottom: 10px;
  }

  .inicio-panel-pagos-list article:not(:nth-of-type(1)){
    margin-left: 0 !important;
  }

  .inicio-main-dash .inicio-extra {
    margin: 0;
    padding: 0 20px;
    width: 350px;
  }

  .inicio-main-dash .inicio-panel {
    box-shadow: 0px 3.05063px 6px rgba(159, 159, 159, 0.16);
    margin-left: auto;
    margin-right: auto;
    min-width: 880px;
    margin-bottom: 0;
  }
  .inicio-extra button,
  .text-info-loans .btn-text-info-loans button,
  #choose-product-loans .choosenBtn button:not(.v-btn--disabled) {
    /* align-items: center;
    background: var(--fuchsia-color) !important;
    display: flex;
    color: white;
    justify-content: center;
    margin: 25px auto 0 auto; */
  }

  .inicio-panel-content {
    margin-left: 25px;
    margin-right: 25px;
  }
  .inicio-panel-banner {
    justify-content: space-around;
  }

  .inicio-panel-banner button {
    height: 39px;
    width: 110px;
  }

  .inicio-panel-banner div {
    margin-right: 10px;
    text-align: center;
  }
  .inicio-panel-block-1-list .v-carousel {
    height: 210px !important;
  }
  .inicio-panel-block-1-list article {
    cursor: pointer;
    transition: .2s ease-in-out;
    max-width: 261px;
    margin-top: 2px;
  }
  .inicio-panel-block-1-list article:hover {
    border: 1px solid var(--first-brand-color);
  }
  /** PARA EL CAROUSEL */
  .inicio-panel-block-1-list .v-carousel .v-carousel__next {
    right: 0;
  }
  .inicio-panel-block-1-list .v-carousel .v-carousel__next button .v-btn__content i {
    font-size: 28px !important;
  }
  .inicio-panel-block-1-list .v-carousel__next .v-btn__content {
    background: transparent;
    cursor: pointer;
    color: transparent;
  }
  .inicio-panel-block-2 {
    gap: 22px;
    align-items: flex-start;
    display: flex;
    justify-content: space-between;
    width: min-content;
  }
  .inicio-panel-block-2.f-wrap {
    flex-wrap: wrap;
  }

  .inicio-panel-block-2 .contactanos{
    margin-top: 0;
    width: fit-content;
  }

  .inicio-extra-gray {
    max-width: 308px;
  }
  .btn-text-info-soat-expiring button {
    background-color: var(--fuchsia-color) !important;
    color: white !important;
    font-family: "Omnes Regular", sans-serif;
    font-size: 16px;
    justify-content: center;
    box-shadow: none !important;
    height: 44px;
    width: 160px;
    border-radius: 5px;
  }
  .card_expired-soat {
    border-radius: 7px;
  }

  .inicio-panel-pagos article:hover,
  .inicio-panel-contacto article:hover {
    border: 1px solid var(--first-brand-color);
  }
  .inicio-panel-pagos .inicio-panel-pagos-list {
    gap: 22px;
    flex-wrap: nowrap;
  }
  .inicio-panel-pagos-list article figure {
    margin-left: 12px;
  }

  /** TOOLTIPS FOR INFO POLIZA IN HOME */
  .v-card.tooltip-dash-info-poliza {
    background-color: var(--text-color);
    border-radius: 5px;
    padding: 15px;
    max-width: 180px;
  }
  .v-card.tooltip-dash-info-poliza span {
    color: #FFF;
  }

  .inicio-panel-banner h3 {
    font-size: 21px;
  }

  .inicio-panel-banner h3.fixed-banner {
    font-size: 17.5px;
    font-family: 'Omnes Medium';
  }

  .inicio-panel-banner p {
    font-size: 18px;
  }

  .inicio-panel-banner article {
    align-items: center;
    display: flex;
    width: 70%;
  }

  .inicio-panel-block-1-list {
    position: relative;
  }

  .inicio-panel-block-1-list article h3 {
    text-align: center;
  }

  .inicio-panel-block-1-list article:not(:nth-of-type(1)) {
    margin-left: 17px;
  }

  #modal-expired-soat {
    padding: 80px 16px;
  }

  /** FOR iPhones Pro */
  @media only screen and (max-width: 799px) {
    .inicio-panel {
      border: 0;
    }
    .inicio-panel-block-1-descrip {
      width: 62% !important;
    }
  }

  .inicio-panel-block-1-btn {
    top: 45%;
    transform: translateY(-50%);
    position: absolute;
    right: -6px;
  }

  .inicio-panel-contacto {
    margin-left: 15px;
  }

  /** PARA EL CAROUSEL */
  .inicio-panel-block-1-list .v-carousel .v-carousel__next {
    right: 0px;
  }

  .inicio-panel-block-1-list .v-carousel .v-carousel__next button {
    cursor: auto;
  }

  .inicio-panel-block-1-list .v-carousel .v-carousel__next button .v-btn__content i {
    font-size: 28px !important;
  }

  .inicio-extra section:nth-of-type(2) {
    max-height: 35.9em;
    overflow-y: auto;
  }

  .inicio-panel-pagos article {
    width: 219px;
  }
}

@media screen and (min-width: 1265px) {
  .inicio-panel-pagos article {
    width: 220px;
  }
}

@media screen and (min-width: 1275px) {
  .inicio-panel-pagos article {
    width: 240px;
  }
}

@media screen and (min-width: 1365px) {
  .inicio-panel-block-1-list article {
    min-width: 260px;
  }
  .inicio-panel-pagos article {
    width: 260px;
  }
}

/**
    * PARA PANTALLA DESKTOP CHICAS
    * ESTO ES ALGO QUE NO SE DEBE HACER PERO LO EXIGEN!
    * WARM: THIS MUST BE CHANGED!
    */
  @media screen and (min-width: 1024px) and (max-width: 1380px) {
    .inicio-panel-block-1-list article {
      max-width: 261px;
    }
    .inicio-extra section:nth-of-type(2) {
      max-height: 35.9em;
      overflow-y: auto;
    }
  }
  @media screen and (min-width: 1024px) and (max-width: 1270px) {
    .inicio-panel {
      min-width: 760px !important;
      width: 770px;
    }
    .inicio-panel-contacto article {
      width: 230px;
    }
    .inicio-panel-contacto article .g-flex {
      margin-left: 15px;
    }
    .inicio-panel-banner p {
      font-size: 15px;
    }
  }
  @media screen and (min-width: 1024px) and (max-width: 1190px) {
    .inicio-panel {
      width: 760px;
    }
  }
  @media screen and (min-width: 1124px) {
    .inicio-panel-banner div {
      margin-right: 7%;
    }
  }
  @media screen and (min-width: 1220px) {
    .inicio-panel-banner div{
      margin: auto !important;
    }
  }
  @media screen and (min-width: 1400px) {
    .inicio-extra section:nth-of-type(2) {
      max-height: 40em;
      overflow-y: auto;
    }
  }

  .v-btn.download-btn-files, #btnDownloadEstado {
    background-color: var(--fuchsia-color) !important;
    color: #fff;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 3px;
    height: auto;
    width: 80%;
    margin: 0;
    text-transform: none;
    padding: 14px 0;
    min-height: 40px;
    height: 40px;
  }

  .inicio-extra section:nth-of-type(2) {
    max-height: 35.9em;
    overflow-y: auto;
  }

  .v-dialog.v-dialog--active.v-dialog--persistent.v-dialog--fullscreen {
    width: 100%;
    height: 100%;
  }

.prestamosvida-banner {
  align-items: flex-start !important;
  text-align: left !important;
}

.prestamosvida-banner h3,
.prestamosvida-banner p,
.prestamosvida-banner div {
  width: 100% !important;
  text-align: left !important;
}

.inicio-panel-banner button.prestamosvida-button {
  width: 100% !important;
  min-width: 220px !important;
  max-width: 220px !important;
  height: 56px !important;
  border-radius: 8px !important;
  font-size: 18px !important;
}

/* Mobile styles for prestamos vida banner */
@media only screen and (max-width: 600px) {
  .inicio-panel-banner.prestamosvida-mobile {
    display: grid !important;
    grid-template-columns: 140px 1fr !important;
    grid-template-rows: 1fr auto auto 1fr !important;
    gap: 0 12px !important;
    padding: 12px 16px 8px 8px !important;
    align-items: center !important;
  }

  .inicio-panel-banner.prestamosvida-mobile figure {
    grid-column: 1 !important;
    grid-row: 1 / 5 !important;
    align-self: end !important;
    width: 140px !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .inicio-panel-banner.prestamosvida-mobile figure img {
    width: 100% !important;
    height: auto !important;
    display: block !important;
  }

  .inicio-panel-banner.prestamosvida-mobile article {
    grid-column: 2 !important;
    grid-row: 2 !important;
    align-self: end !important;
    width: 100% !important;
    margin: 0 0 8px 0 !important;
  }

  .inicio-panel-banner.prestamosvida-mobile article div {
    width: 100% !important;
    margin: 0 !important;
  }

  .inicio-panel-banner.prestamosvida-mobile h3 {
    text-align: left !important;
    font-size: 18px !important;
    line-height: 1.3 !important;
    margin-bottom: 4px !important;
  }

  .inicio-panel-banner.prestamosvida-mobile p {
    text-align: left !important;
    font-size: 14px !important;
    line-height: 1.4 !important;
    margin-bottom: 0 !important;
  }

  .inicio-panel-banner.prestamosvida-mobile button.prestamosvida-button {
    grid-column: 2 !important;
    grid-row: 3 !important;
    align-self: start !important;
    justify-self: start !important;
    width: auto !important;
    max-width: none !important;
    min-width: auto !important;
    height: 40px !important;
    padding: 0 16px !important;
    margin: 0 !important;
    font-size: 14px !important;
    border-radius: 8px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue